import React, { useEffect, useState, useContext, useRef } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faEye, faL } from '@fortawesome/free-solid-svg-icons';
import SidebarList from "./SidebarList";
import PageHeader from '../../components/common/PageHeader/index';
import FileDetail from "./FileList/FileDetail";
import { navigationAction } from "../../context/actions/navigationAction";
// import { documentLogListing } from '../../context/actions/document';

import { Button } from "reactstrap";
import {getAllCUTVDocuments, getDocuments, getDocumentsById,findDocumentsById, getDocumentsByIdWithTypes, getDocumentsWithTypes, getDocumentsList, updateDocumentFile, updateDocumentFileStatus, deleteDocumentFile, appendDocumentsById, getElasticSearchFolders, getFileDoc,getFile,getUnlabeledFileDoc, getDocumentTypes,getDocumentsStatic, updateloanlist ,unlockDoc, getAllReviewRequestedDocuments, getAllOtherDocuments, getAllLabeledDocuments, getMainParent, getAllOtherLabeledDocuments,getFileByRevision} from "../../context/actions/document";
import { getFileSetting } from "../../context/actions/fileSetting";

import { set_archive_filter, set_page } from "../../context/actions/general";
import '../../assets/css/common/document/index.scss';
import { useDispatch, useSelector } from "react-redux";
import { pagination, documentFilterItems, statusOptions, toasterConfig } from '../../utils/constants';
import BackButton from "../../components/common/BackButton";
import FileSearchBlock from "./FileSearchBlock";
import SortFilterDropdown from "../../components/common/SortFilterDropdown";
import { navigationAction2 } from "../../context/actions/navigationAction2";
import { useHistory } from "react-router-dom";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import FilterDropdown from "../../components/common/FilterDropdown";
import { SocketContext, backendSocket } from '../../context/actions/socket';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { rightsidebar } from "../../context/actions/document";
import AutoSaveDataModal from "../Dashboard/AutoSaveData/AutoSaveDataModal";
import FilesInfoWrappper from "./FilesInfoWrappper";
import PaymentFailedModal from "../Pricing/PaymentFailedModal";
import ReadOnly from './FilesInfoWrappper/ReadOnly';
import EditReadOnlyPermission from './FilesInfoWrappper/EditReadOnlyPermission';
import { useLocation } from "react-router-dom";


toast.configure();
const MySwal = withReactContent(Swal)
const Documents = () => {
	const dispatch = useDispatch();
	const location = useLocation();

	useEffect(() => {
		window.onbeforeunload = function () {
			dispatch({ type: "UPDATE_DOCUMENT_FILTER", data: '' });  // on pageload set previously filter value to ''
			dispatch({ type: "UPDATE_FOLDER_LABEL", data: 4 });  // on pageload set previously label value to CR-VR
			dispatch({ type: "UPDATE_FOLDER_SORT", data: 2 });  // on pageload set previously label value to CR-VR
		};
	}, []);

	const active_loan = location?.state?.activeLoan;
	const _select_Folder_id = location?.state?._select_Folder_id;

	
	const [elementPos, setElementPos] = useState(0)
	const { socket } = useContext(SocketContext);
	const user = useSelector((state) => state.user.user); // get current user details
	let queueCount = useSelector((state) => state.document.queueCount); // get current organization  queue files count
	let filter = useSelector((state) => state.document.filter); // get previously filter value
	let [search, setSearch] = useState('');
	let [sortByValue, setSortByValue] = useState('createdAt');
	let [sortByName, setSortByName] = useState('Date');
	const [selectedQuery, setSelectedQuery] = useState()
	let [order, setOrder] = useState('-1');
	let [keyWord, setKeyWord] = useState('');
	// const [sortBySelected, setSortBySelected] = useState('2');
	const [sortBySelected, setSortBySelected] = useState(useSelector((state) => state.document.folderSort))
	// const [filterSelected, setFilterSelected] = useState(4);
	const [filterSelected, setFilterSelected] = useState(useSelector((state) => state.document.folderLabel));
	const [myAssignedSelected, setMyAssignedSelected] = useState(false);
	let [fileRefreshFlag, setFileRefreshFlag] = useState(false);
	let [folderRefreshFlag, setFolderRefreshFlag] = useState(false);
	const userData = useSelector((state) => state.user.user);
	const [disabled, setDisabled] = useState(false);
	const [sortFn, setSortFn] = useState(0);
	const [sidebarActivePacketIndex, setsidebarActivePacketIndex] = useState(active_loan && active_loan ? active_loan:0);
	const [label, setLabel] = useState('');
	const [dropData, setDropData] = useState({ name: '', toggled: true, children: [] })
	const [dropdownData, setDropdownData] = useState({});
	const [cursor, setCursor] = useState(false);
	const [type, setType] = useState();
	const [unableToValidate, setUnableToValidate] = useState()
	const [docInreview, setDocInreview] = useState()
	const [otherDocuments, setOtherDocuments] = useState()
	let [labelStatus,setLabelStatus] = useState('')
	let [isArchived, setIsArchived] = useState(useSelector((state)=>state.general.isArchive))
	let [filterpayload,setFilterPayload] = useState({});
	const [documentList, setDocumentList] = useState();
	const [labeledDocsPage, setLabeledDocsPage] = useState({});
    const [selectedDocument, setSelectedDocument] = useState();
	const userDetail = useSelector((state) => state?.user?.user);
	const [showModal,setShowModel] = useState(false);
	const [hasNextPage, setHasNextPage] = useState(useSelector((state) => state.document?.hasNextFolderPage))
	const [hasPrevPage, setHasPrevPage] = useState(useSelector((state) => state.document?.hasPrevFolderPage))
	const [showPermissionModal,setShowPermissionModal] = useState(false);
	const [otherDocs, setOtherDocs] = useState();
	const [otherDocsPreviousPage, setOtherDocsPreviousPage] = useState(false)
	const [reviewRequestedCount, setReviewRequestedCount] = useState(0);
	const [otherDocsCount, setOtherDocsCount] = useState(0);
	// const [page, setPage] = useState(pagination.page)
	const [typeMainParent, setTypeMainParent] = useState()
	const [labeledData, setLabeledData] = useState()
	const [reviewRequestedData, setReviewRequestedData] = useState({})
	const [otherDocsData, setOtherDocsData] = useState({})
	const [otherLabeledDocsData, setOtherLabeledDocsData] = useState({});
	const [isReviewRequestLoading, setIsReviewRequestLoading] = useState(false);
	const [isOtherDocsLoading, setIsOtherDocsLoading] = useState(false);
	const [isLabeledDataLoading, setIsLabeledDataLoading] = useState(false);
	const [FilterType, setFilterType] = useState(false);
	const [typeSelected, setTypeSelected] = useState("");
	const [typeSelectedGrandParent, setTypeSelectedGrandParent] = useState("");
	const [typeSelectedParent, setTypeSelectedParent] = useState("");
	const [typeSelectedChild, setTypeSelectedChild] = useState("");
	const [archiveSelected, setArchiveSelected] = useState(false);
	// const [totalPages, setTotalPages] = useState(0)
	const [page, setPage] = useState(useSelector((state) => state.document.folderPage))
	const [totalPages , setTotalPages] = useState(useSelector((state) => state.document.totalPages))
	

	useEffect(() => {
		setLoader(true);
		dispatch(set_page(1));
		setSearch(filter);
		setLabel('CR OR VR');
		setIsArchived(false)
		setFilterPayload({ fields: "name, loan_number", sort: 'updatedAt', order: -1, filter: filter, limit: paginations, page: 1, label: 'CR OR VR', deleted : status, myAssigned: myAssignedSelected })
		if(_select_Folder_id)
			{  
				setDocId(_select_Folder_id)
				setLoader(true);
				// setElementPos(active_loan)
				dispatch(getDocumentsByIdWithTypes({ deleted : status,folder: _select_Folder_id, limit: paginations, sort : sortByValue, order: order, fields: 'name', filter: keyWord, type,label:labelStatus }, ((result) => {
					let docDta = folders.find(({ _id }) => _id === docId);
					setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
					setFolder(docDta && docDta?.type ? docDta?.type : {});
					console.log('JID 1')
					setDocumentList(result)
					// setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
					// setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")


					dispatch(getAllReviewRequestedDocuments({folder:  _select_Folder_id, deleted: status, limit: paginations, sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, myAssigned: myAssignedSelected}, async (reviewrequestedresult)=>{
						setReviewRequestedData(reviewrequestedresult)
						setDocumentDetail(reviewrequestedresult?.docs[0])
						setSelectedDocument(reviewrequestedresult?.docs[0]?._id)
						setReviewRequestedCount(reviewrequestedresult?.totalDocs)
						
						// dispatch(getAllOtherDocuments({folder:  _select_Folder_id, limit: paginations, deleted: status, sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, myAssigned: myAssignedSelected}, (otherDocsResult)=>{
						// 	setOtherDocsData(otherDocsResult)
						// 	setOtherDocs(otherDocsResult.docs)
						// 	setOtherDocsCount(otherDocsResult?.totalDocs)

							dispatch(getMainParent({}, async (data)=>{
								setTypeMainParent(data)
								var labeledDataArr = [];
								for (let i = 0; i < data.length; i++) {
									const labeledresult = await new Promise(resolve => {
										dispatch( getAllLabeledDocuments({ folder:  _select_Folder_id, mainparent: data[i]?._id, limit: paginations, deleted: status, sort: sortByValue, order: order, fields: 'name', filter: keyWord, label: labelStatus, limit: 10, myAssigned: myAssignedSelected }, resolve ));
									});
									if (labeledresult.docs.length > 0) {
										labeledDataArr.push(labeledresult);
									}

									const CUTVresult = await new Promise(resolve => {
										dispatch(getAllCUTVDocuments({ folder:  _select_Folder_id, mainparent: data[i]?._id, limit: paginations, deleted: status, sort: sortByValue, order: order, fields: 'name', filter: keyWord, label: labelStatus, limit: 10, myAssigned: myAssignedSelected }, resolve ));
									});

									if (CUTVresult.docs.length > 0) {
										labeledDataArr.push(CUTVresult);
									}
									if(i == data?.length -1 ){
										setLoader(false );
									}
								}
								setLabeledData(labeledDataArr);
								_getDocumentTypes(_select_Folder_id, status, myAssignedSelected)
							}))
		
							
						// }))
					}))
				})));
			} 
			else {	
			
				setPage(pagination.page)
				dispatch({ type: "UPDATE_FOLDER_LABEL", data: 4 });  // on pageload set previously label value to CR-VR
				dispatch({ type: "UPDATE_FOLDER_SORT", data: 2 });  // on pageload set previously label value to CR-VR
				setFilterSelected(4)
				setSortBySelected(2)
				dispatch(getDocumentsWithTypes({ fields: "name, loan_number", sort: 'updatedAt', order: -1, filter: filter, limit: paginations, page: 1, label: 'CR OR VR', deleted : status, myAssigned: myAssignedSelected }, ((result) => { // for default folders filter
					setHasNextPage(result.hasNextPage)
					setHasPrevPage(result.hasPrevPage)
					setTotalPages(result.totalPages)
					let docDta = folders.find(({ _id }) => _id === docId);
					setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
					setFolder(docDta && docDta?.type ? docDta?.type : {});
			
					let documentSelected = false;
					dispatch(getAllReviewRequestedDocuments({folder: result?.docs[0]?._id, limit: paginations, deleted: status, sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, myAssigned: myAssignedSelected}, async (reviewrequestedresult)=>{
						if(reviewrequestedresult?.docs?.length > 0 ){
							documentSelected = true
						}
						setReviewRequestedData(reviewrequestedresult)
						setDocumentDetail(reviewrequestedresult?.docs[0])
						setSelectedDocument(reviewrequestedresult?.docs[0]?._id)
						setReviewRequestedCount(reviewrequestedresult.totalDocs)

						// dispatch(getAllOtherDocuments({folder: result?.docs[0]?._id, limit: paginations, deleted: status, sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, myAssigned: myAssignedSelected}, (otherresult)=>{
						// 	setOtherDocsData(otherresult)
						// 	setOtherDocs(otherresult.docs)
						// 	setOtherDocsCount(otherresult.totalDocs)

							dispatch(getMainParent({}, async (data)=>{
								setTypeMainParent(data)
								var labeledDataArr = [];
								var pages = {}
								for (let i = 0; i < data.length; i++) {
									const labeledresult = await new Promise(resolve => {
										dispatch(getAllLabeledDocuments({ folder: result?.docs[0]?._id, mainparent: data[i]?._id, limit: paginations, deleted: status, sort: sortByValue, order: order, fields: 'name', filter: keyWord, label: labelStatus, limit: 10, myAssigned: myAssignedSelected }, resolve ));  
									});
									if (labeledresult.docs.length > 0) {
										pages = {...pages, [data[i]?._id] : 1}
										labeledDataArr.push(labeledresult);
									}

									const CUTVresult = await new Promise(resolve => {
										dispatch(getAllCUTVDocuments({ folder: result?.docs[0]?._id, mainparent: data[i]?._id, limit: paginations, deleted: status, sort: sortByValue, order: order, fields: 'name', filter: keyWord, label: labelStatus, limit: 10, myAssigned: myAssignedSelected }, resolve ));  
									});

									if (CUTVresult.docs.length > 0) {
										pages = {...pages, [data[i]?._id] : 1}
										labeledDataArr.push(CUTVresult);
									}
									if(i == data?.length -1 ){
										setLoader(false)
									}
								}
								setLabeledDocsPage(pages)
								setLabeledData(labeledDataArr);
								if(result?.docs[0]?._id){
									_getDocumentTypes(result?.docs[0]?._id)
								}else{
									setLoader(false)
								}
							}))
						// }))
					}))
					console.log('JID 2')
					setDocumentList(result?.docs[0]?.documents)
					// setDocumentDetail(result?.docs[0]?.documents?.review_requested?.docs[0] ? result?.docs[0]?.documents?.review_requested?.docs[0] : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0] : result?.docs[0]?.documents?.other_documents?.docs[0] ? result?.docs[0]?.documents?.other_documents?.docs[0] : {})

					// setSelectedDocument(result?.docs[0]?.documents?.review_requested?.docs[0]?._id ? result?.docs[0]?.documents?.review_requested?.docs[0]?._id : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0]?._id : result?.docs[0]?.documents?.other_documents?.docs[0]?._id ? result?.docs[0]?.documents?.other_documents?.docs[0]?._id : {})
					
				})));

			// dispatch(getFileSetting(((result) => {
			// 	// setLoader(false);
			// })));
			}
			if (user) {
				console.log('user code hitting ....')
				activeQueueStatus(user?.organization)
			}
		}, [user]);

	/**
  * @description method call to get all documet types
  */
	const _getDocumentTypes = async (folderId, deleted, assignedval, archived) => {
		dispatch(getDocumentTypes({ limit: pagination.maxlimit, deleted : deleted ? deleted : false, folderId: folderId ? folderId : docId, myAssigned: assignedval != undefined && assignedval != null ? assignedval : myAssignedSelected, archived : archived }, (res) => {
			res.tree[0].children[0].children[0].active = true
			res.tree[0].children[0].children[0].terminal = true
			let newdata = { ...dropData, children: res?.tree };
			setDropData(newdata);
			setLoader(false);
		}))
	}


	useEffect(() => {
		console.log('file/folder refresh code hitting.')
		activeQueueStatus(user?.organization)
        dispatch(set_archive_filter(false))
	}, [fileRefreshFlag, folderRefreshFlag]);

	const getSortParams = (sortBySelected) => {
		switch (Number(sortBySelected)) {
			case 1: return { sort: 'updatedAt', order: 1 };
			case 2: return { sort: 'updatedAt', order: -1 };
			case 3: return { sort: 'loan_number', order: 1 };
			case 4: return { sort: 'loan_number', order: -1 };
			default: return { sort: 'updatedAt', order: -1 };
		}
	};


	const navigationState = useSelector((state) => state.navigationReducer.isOn);
	const editorVisible = useSelector((state) => state.navigationReducer2.isOn2);


	const navigationHandler = () => {
		dispatch(navigationAction(!navigationState));
	}
	const sidebarEditorHandler = () => {
		dispatch(navigationAction2(!editorVisible));
	}

	const overClickHandler = () => {
		dispatch(navigationAction(false));
		dispatch(navigationAction2(false));
	}
	const history = useHistory();
	const [sidebarLoading, setSidebarLoading] = useState(false);
	const [sidebarLoadingLabel, setSidebarLoadingLabel] = useState('View More');
	const [sidbarLoadingButton, setSidbarLoadingButton] = useState(false);
	const [fileLoading, setFileLoading] = useState(false);
	const [fileLoadingLabel, setFileLoadingLabel] = useState('View More');
	const [fileLoadingButton, setFileLoadingButton] = useState(false);
	const [status, setStatus] = useState(false)
	const [reviewRequestedPage, setReviewRequestedPage] = useState(pagination.page);
	const [otherDocsPage, setOtherDocsPage] = useState(pagination.page);
	const [otherLabeledDocsPage, setOtherLabeledDocsPage] = useState(pagination.page);
	const [paginations] = useState(pagination.docLimit);
	const [filePage, setFilePage] = useState(pagination.page);
	const [loader, setLoader] = useState(false);
	const [innerLoader, setInnerLoader] = useState(false);
	const documentMenu = useSelector((state) => state.document.documentMenu || []);
	let folders = useSelector((state) => state.document.folderRecords);
	let totalFolderRecords = useSelector((state) => state.document.totalFolderRecords);
	let totalDocRecords = useSelector((state) => state.document.totalDocRecords);
	const [docId, setDocId] = useState(documentMenu !== undefined && documentMenu.docs !== undefined && documentMenu.docs.length ? documentMenu.docs[0]._id : null)
	const [tags, setTags] = useState(documentMenu !== undefined && documentMenu.docs !== undefined && documentMenu.docs.length ? documentMenu.docs[0].tags : []);
	const [folder, setFolder] = useState(documentMenu !== undefined && documentMenu.docs !== undefined && documentMenu?.docs.length ? documentMenu?.docs[0] : null);
	const [documentDetail, setDocumentDetail] = useState(documentMenu !== undefined && documentMenu.docs !== undefined && documentMenu.docs.length && documentMenu.docs[0].documents.length ? documentMenu.docs[0].documents[0] : {});
	const [selectedFileId, setSelectedFileId] = useState(documentMenu !== undefined && documentMenu.docs !== undefined && documentMenu.docs.length && documentMenu.docs[0].documents.length ? documentMenu.docs[0].documents[0]?._id : null);
	const [selectedIconId, setSelectedIconId] = useState(null);
	let [payload, setPayload] = useState({ limit: paginations, page: 1 });
	let [initialpayload,setinitialpayload] = useState({})
	let [elasticPayload, setElasticPayload] = useState({});
	const [elasticSearchList, setElasticSearchList] = useState([]);
	let [focusSearchFlag, setFocusSearchFlag] = useState(false);

	useEffect(()=> {
		setArchiveSelected(status)
	}, [status])


	/**
	 * @description function intialization socket queue-<organization> file status realtime update
	 */
	const activeQueueStatus = (organization) => {

		console.log('working 123456')
		
		socket.off(`queue-${organization}`).on(`queue-${organization}`, (res) => {
			console.log('working 123456 queue')
			if (res?.data?.processed === 100) {
				dispatch({ type: "UPDATE_QUEUE_COUNT" });
				dispatch({ type: "ENABLE BUTTON", data: true })
				dispatch(set_archive_filter(false))
				/*toast.dismiss();
				toast.success(res?.message, toasterConfig);
				setLoader(true);
				dispatch(getDocuments({ fields: "name, loan_number", filter: '', limit: paginations, page: page }, ((result) => {
					setSortBySelected(null)
					setFilterSelected(null)
					setLoader(false);
				})));*/
			}
		})
		socket.off(`cron-queue-${organization}`).on(`cron-queue-${organization}`, (res) => {
			console.log('working.....')
			if (!totalFolderRecords) {  // if no folders 
				console.log('working 111')
				setLoader(true);
				dispatch(getDocumentsWithTypes({ fields: "name,loan_number", filter: '', limit: paginations, page: page }, ((result) => {
					setTotalPages(result.totalPages)
					setSortBySelected(null)
					setFilterSelected(null)
					setLoader(false);
					
				})));
			} else {
				if (docId == res.data.folder) {
					console.log('working 222')
					dispatch({ type: "APPEND_TOTAL_RECORDS", data: 1, foldercount: res.foldercount });
					if (res?.data?.is_correct == 2) {
						dispatch({ type: "UPDATE_SELECTED_FOLDER", data: res.data });
					}
					if (!fileRefreshFlag) {
						toast.success('Some New Files have been added please click refresh button', toasterConfig);
						setFileRefreshFlag(true)
					}
				} else {
					console.log('working 333')
					if (res.foldercount > totalFolderRecords) {
						dispatch({ type: "APPEND_TOTAL_RECORDS", data: 0, foldercount: res.foldercount });
						if (!folderRefreshFlag) {
							toast.success('Some New Folder have been added please click refresh button', toasterConfig);
						}
					}
					setFolderRefreshFlag(true)
				}
			}
		})
	}

	/**
	 * @description method call to select document from leftside bar listing 
	 * @param {*} docId selected doc id 
	 * @returns 
	 */
	const _handleSelected = async (docId, docIndex, type, parent) => {
		setType("")
		let deleted = false;
		setLoader(true);
		if(labelStatus == "Archived"){
			deleted = true;
			setStatus(true);
			setArchiveSelected(true)
			setIsArchived(true);
			dispatch(set_archive_filter(true))
		}else{
			setIsArchived(false)
			setSelectedQuery("")
			setStatus(false);
			setArchiveSelected(false)
			dispatch(set_archive_filter(false))
		}
		setElementPos(docIndex)
		setFilePage(pagination.page);
		setDocId(docId);
		dispatch(set_page(1));
		setReviewRequestedPage(1)
		setOtherDocsPage(1)
		setOtherLabeledDocsPage(1)
		setOtherDocs([])
		setOtherLabeledDocsData({})
		setOtherDocuments(false)
		setTypeSelected("");
		setTypeSelectedChild("");
		setTypeSelectedParent("");
		setTypeSelectedGrandParent("");
		docIndex && docIndex != '' ? setsidebarActivePacketIndex(docIndex) : setsidebarActivePacketIndex(0);
		dispatch(getDocumentsByIdWithTypes({ deleted : deleted, folder: docId, limit: paginations, sort : sortByValue, order: order, fields: 'name', filter: keyWord, type, parent : parent,label:labelStatus, myAssigned: myAssignedSelected }, ((result) => {
			// _getDocumentTypes(docId, status)
			
			let docDta = folders.find(({ _id }) => _id === docId);
			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			setFolder(docDta && docDta?.type ? docDta?.type : {});
			console.log('JID 3')
			setDocumentList(result)
			// setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
			// setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
			// setLoader(false);
			// setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)
		})));

		let documentSelected = false
		dispatch(getAllReviewRequestedDocuments({folder: docId,  sort : sortByValue, deleted: deleted, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10,  myAssigned: myAssignedSelected}, async (result)=>{
			if(result?.docs?.length > 0) {
				documentSelected = true
			}
			// _getDocumentTypes(docId, status)
			let docDta = folders.find(({ _id }) => _id === docId);
			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			setFolder(docDta && docDta?.type ? docDta?.type : {});
			setReviewRequestedData(result)
			setDocumentDetail(result?.docs[0])
			setSelectedDocument(result?.docs[0]?._id)
			setReviewRequestedCount(result.totalDocs)

			// dispatch(getAllOtherDocuments({folder: docId, sort : sortByValue, order: order, fields: 'name', otherDocuments: true, deleted: deleted, filter: keyWord, label:labelStatus, limit: 10,  myAssigned: myAssignedSelected}, async (otherresult)=>{
			// 	setOtherDocsData(otherresult)
			// 	setOtherDocs(otherresult.docs)
			// 	setOtherDocsCount(otherresult.totalDocs)

				var labeledDataArr = [];
				var pages = {}
					for (let i = 0; i < typeMainParent.length; i++) {
						const labeledresult = await new Promise(resolve => {
							dispatch( getAllLabeledDocuments({folder: docId, mainparent: typeMainParent[i]?._id, sort : sortByValue, deleted: deleted, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, myAssigned: myAssignedSelected}, resolve ));
						});
						if (labeledresult.docs.length > 0) {
							pages = {...pages, [typeMainParent[i]?._id] : 1}
							labeledDataArr.push(labeledresult);
						}

						const CUTVresult = await new Promise(resolve => {
							dispatch(getAllCUTVDocuments({folder: docId, mainparent: typeMainParent[i]?._id, sort : sortByValue, deleted: deleted, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, myAssigned: myAssignedSelected}, resolve ));
						});

						if (CUTVresult.docs.length > 0) {
							pages = {...pages, [typeMainParent[i]?._id] : 1}
							labeledDataArr.push(CUTVresult);
						}
						if(i == typeMainParent?.length -1 ){
							setLoader(false)
						}
					}
					if(!documentSelected){
						// if(otherresult?.docs?.length > 0){
						// 	setDocumentDetail(otherresult?.docs[0])
						// 	setSelectedDocument(otherresult?.docs[0]?._id)
						// } else {
							setDocumentDetail(labeledDataArr[0]?.docs[0])
							setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
						// }
					}
					_getDocumentTypes(docId, deleted, myAssignedSelected)
					setLabeledDocsPage(pages)
					setLabeledData(labeledDataArr);
					
			}))
		// }))
		
		dispatch(navigationAction(!navigationState));
	};

	// Review Requested Docs Page Handle
	const reviewRequestedPageHandle = (page) =>{
		setIsReviewRequestLoading(true)
		setReviewRequestedPage(page)
		dispatch(getAllReviewRequestedDocuments({folder: docId, sort: sortByValue, order: order, limit: 10, page: page, deleted: labelStatus != "Archived" ? archiveSelected : status , filter: keyWord, fields: "name", type : type, unableToValidate: unableToValidate, otherDocuments: otherDocuments, docInreview: docInreview, myAssigned: myAssignedSelected}, (result)=>{
			setReviewRequestedData(result)
			setDocumentDetail(result?.docs[0])
			setSelectedDocument(result?.docs[0]?._id)
			setReviewRequestedCount(result.totalDocs)
			setIsReviewRequestLoading(false)
		}))
	}

	// Review Requested Docs Page Handle
	const labeledPageHandle = (page, mainparent, parentName) =>{
		console.log(labeledDocsPage)
		setIsLabeledDataLoading(true)
		setLabeledDocsPage((previousState)=>{
			return {
				...previousState,
				[mainparent] : page
			}
		})
		if (parentName.includes("Complete or UTV")) {
			dispatch(getAllCUTVDocuments({ folder: docId, sort: sortByValue, order: order, limit: 10, page: page, deleted: labelStatus != "Archived" ? archiveSelected : status, filter: keyWord, fields: "name", type: type, unableToValidate: unableToValidate, otherDocuments: otherDocuments, docInreview: docInreview, mainparent: mainparent, myAssigned: myAssignedSelected }, (result) => {
				setLabeledData((previousState) => {
					let index = previousState.findIndex(obj => obj.mainparentName === parentName);
					if (index === -1) {
						index = previousState[0]?.docs.findIndex(obj => obj.mainparentName === parentName);
					}
					// Create a new array with the changes
					const newArr = [...previousState];
					newArr[index] = result;
					return newArr;
				});
				setIsLabeledDataLoading(false)
			}))
		} else {
			dispatch(getAllLabeledDocuments({ folder: docId, sort: sortByValue, order: order, limit: 10, page: page, deleted: labelStatus != "Archived" ? archiveSelected : status, filter: keyWord, fields: "name", type: type, unableToValidate: unableToValidate, otherDocuments: otherDocuments, docInreview: docInreview, mainparent: mainparent, myAssigned: myAssignedSelected }, (result) => {
				setLabeledData((previousState) => {
					let index = previousState.findIndex(obj => obj.mainparentId === mainparent);
					if (index === -1) {
						index = previousState[0]?.docs.findIndex(obj => obj.type_mainparent === mainparent);
					}
					// Create a new array with the changes
					const newArr = [...previousState];
					newArr[index] = result;
					return newArr;
				});
				setIsLabeledDataLoading(false)
			}))
		}

	}

	// labeled Docs Page Handle
	const otherDocsPageHandle = (page) =>{
		setIsOtherDocsLoading(true)
		setOtherDocsPage(page)
		dispatch(getAllOtherDocuments({folder: docId, sort: sortByValue, order: order, limit: 10, page: page, deleted: labelStatus != "Archived" ? archiveSelected : status, filter: keyWord, fields: "name", type : type, unableToValidate: unableToValidate, otherDocuments: otherDocuments, docInreview: docInreview, myAssigned: myAssignedSelected}, (result)=>{
			setOtherDocsData(result)
			setOtherDocs(result.docs)
			setDocumentDetail(result?.docs[0])
			setSelectedDocument(result?.docs[0]?._id)
			setOtherDocsCount(result.totalDocs)
			setIsOtherDocsLoading(false)
		}))
	}

	// labeled Docs Page Handle
	const otherLabeledDocsPageHandle = (page) =>{
		setIsOtherDocsLoading(true)
		setOtherLabeledDocsPage(page)
		dispatch(getAllOtherLabeledDocuments({folder: docId, sort: sortByValue, order: order, limit: 10, page: page, deleted: labelStatus != "Archived" ? archiveSelected : status, filter: keyWord, fields: "name", type : type, unableToValidate: unableToValidate, otherDocuments: otherDocuments, docInreview: docInreview, myAssigned: myAssignedSelected}, (result)=>{
			setOtherLabeledDocsData(result)
			setDocumentDetail(result?.docs[0])
			setSelectedDocument(result?.docs[0]?._id)
			setIsOtherDocsLoading(false)
		}))
	}

	// refresh folders
	const refreshFolders = async () => {
		console.log('refresh function ? ->, loan list reload')
		if(documentMenu?.docs.length)
		{
	    setKeyWord("")
		setSortByName('Date')
		setFolderRefreshFlag(false);
		setFileRefreshFlag(false);
		setLoader(true);
		setInnerLoader(true)
		dispatch(set_page(1));
		dispatch(getDocumentsWithTypes( {...filterpayload, myAssigned: myAssignedSelected}, ((result) => { //so that reset button shows original docs present in side bar (issue 392)
			setTotalPages(result.totalPages)
			setsidebarActivePacketIndex(0)
			setInnerLoader(false);
			setSidbarLoadingButton(true);
			let docDta = folders.find(({ _id }) => _id === docId);
			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			setFolder(docDta && docDta?.type ? docDta?.type : {});
			// refresh indexing count 
			setDocumentList(result?.docs[0]?.documents)
			// setDocumentDetail(result?.docs[0]?.documents?.review_requested?.docs[0] ? result?.docs[0]?.documents?.review_requested?.docs[0] : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0] : result?.docs[0]?.documents?.other_documents?.docs[0] ? result?.docs[0]?.documents?.other_documents?.docs[0] : {})
			// setSelectedDocument(result?.docs[0]?.documents?.review_requested?.docs[0]?._id ? result?.docs[0]?.documents?.review_requested?.docs[0]?._id : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0]?._id : result?.docs[0]?.documents?.other_documents?.docs[0]?._id ? result?.docs[0]?.documents?.other_documents?.docs[0]?._id : {})

			dispatch(getAllReviewRequestedDocuments({folder: result?.docs[0]?._id, limit: paginations, deleted: status, sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, myAssigned: myAssignedSelected}, (reviewrequestedresult)=>{
				setReviewRequestedData(reviewrequestedresult)
				setDocumentDetail(reviewrequestedresult?.docs[0])
				setSelectedDocument(reviewrequestedresult?.docs[0]?._id)
				setReviewRequestedCount(reviewrequestedresult.totalDocs)

				// dispatch(getAllOtherDocuments({folder: result?.docs[0]?._id, limit: paginations, deleted: status, sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, myAssigned: myAssignedSelected}, (otherresult)=>{
				// 	setOtherDocs(otherresult.docs)
				// 	setOtherDocsCount(otherresult.totalDocs)

					dispatch(getMainParent({}, async (data)=>{
						setTypeMainParent(data)
						var labeledDataArr = [];
						var pages = {}
						for (let i = 0; i < data.length; i++) {
							const labeledresult = await new Promise(resolve => {
								dispatch(getAllLabeledDocuments({ folder: result?.docs[0]?._id, mainparent: data[i]?._id, limit: paginations, deleted: status, sort: sortByValue, order: order, fields: 'name', filter: keyWord, label: labelStatus, limit: 10, myAssigned: myAssignedSelected }, resolve ));
							});
							if (labeledresult.docs.length > 0) {
								pages = {...pages, [data[i]?._id] : 1}
								labeledDataArr.push(labeledresult);
							}

							const CUTVresult = await new Promise(resolve => {
								dispatch(getAllCUTVDocuments({ folder: result?.docs[0]?._id, mainparent: data[i]?._id, limit: paginations, deleted: status, sort: sortByValue, order: order, fields: 'name', filter: keyWord, label: labelStatus, limit: 10, myAssigned: myAssignedSelected }, resolve ));
							});
	
							if (CUTVresult.docs.length > 0) {
								pages = {...pages, [data[i]?._id] : 1}
								labeledDataArr.push(CUTVresult);
							}							

							if(i == data?.length -1 ){
								setLoader(false)
							}
						}
						setLabeledDocsPage(pages)
						setLabeledData(labeledDataArr);
						_getDocumentTypes(result?.docs[0]?._id, status)
					}))
				// }))
			}))

			setReviewRequestedPage(1);
			setOtherDocsPage(1);
		})));
		if(labelStatus == 'Archived'){
		   dispatch(set_archive_filter(true))
		}else{
			dispatch(set_archive_filter(false))
		}
	}
	};

	const handleDocSelection = (data) => {
		setSelectedDocument(data?._id)
	}

	// const resetDocs = (v) => {
	// 	_resetFilter(v)
	// 	setKeyword('')
	// 	__filterSelected(null);
	// 	__sortBySelected('2');
	// 	__filterDocs('updatedAt', '-1', '2', false);
	// 	_filterDocs(null, false)
	// 	// setFilterSelected(null);
	// 	//setSortBySelected(null);
	// }

	const _changeFilesStatus = async (status, doctype) => {
		setIsArchived(JSON.parse(status))
		setOtherDocuments(false)
		setStatus(JSON.parse(status))
		if(JSON.parse(status)){
			setSelectedQuery("archive")
		}else{
			setSelectedQuery("")
		}
		 if(documentMenu?.docs?.length)
		 {
		setLoader(true);
		setFilePage(pagination.page);
		dispatch(set_page(1));
		setOtherDocs([])
		setOtherLabeledDocsData({})
		setReviewRequestedPage(1)
		setOtherDocsPage(1)
		setOtherLabeledDocsPage(1)
		setLabeledDocsPage(1)
		// dispatch(getDocumentsByIdWithTypes({ folder: docId, limit: paginations, sort : sortByValue, order: order, fields: 'name', filter: keyWord, type : doctype ? doctype : type, deleted : JSON.parse(status), unableToValidate: unableToValidate, otherDocuments: otherDocuments, docInreview: docInreview}, ((result) => {
		// 	dispatch({ type: "LIST_DOCUMENT", data: result?.review_requested?.docs, totalDocRecords: result.count, folder: docId });
		// setElementPos(elementPos)
		// setStatus(status);
		// setLoader(true);
		// setFilePage(pagination.page);
		// dispatch(set_page(1));

		// elementPos && elementPos != '' ? setsidebarActivePacketIndex(elementPos) : setsidebarActivePacketIndex(0)
		// 	let docDta = folders.find(({ _id }) => _id === docId);
		// 	setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
		// 	setFolder(docDta && docDta?.type ? docDta?.type : {});
		// 	setDocumentList(result)
		// 	setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
		// 	setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
		// 	// setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)
		// })));

		let documentSelected = false;
		dispatch(getAllReviewRequestedDocuments({folder: docId, deleted: JSON.parse(status), limit: paginations, sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, myAssigned: myAssignedSelected}, async (result)=>{
			if(result?.docs?.length > 0) {
				documentSelected = true;
			}
			setReviewRequestedData(result)
			setDocumentDetail(result?.docs[0])
			setSelectedDocument(result?.docs[0]?._id)
			// setReviewRequestedCount(result.totalDocs)

			// dispatch(getAllOtherDocuments({folder: docId, limit: paginations, deleted: JSON.parse(status), sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, myAssigned: myAssignedSelected}, async (otherresult)=>{
			// 	setOtherDocsData(otherresult)
			// 	setOtherDocs(otherresult.docs)
			// 	setOtherDocsCount(otherresult.totalDocs)
				

				var labeledDataArr = [];
				for (let i = 0; i < typeMainParent.length; i++) {
					const labeledresult = await new Promise(resolve => {
						dispatch( getAllLabeledDocuments({folder: docId, limit: paginations, deleted: JSON.parse(status), sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, mainparent: typeMainParent[i]?._id, myAssigned: myAssignedSelected}, resolve ));
					});
					if (labeledresult.docs.length > 0) {
						labeledDataArr.push(labeledresult);
					}

					const CUTVresult = await new Promise(resolve => {
						dispatch(getAllCUTVDocuments({folder: docId, limit: paginations, deleted: JSON.parse(status), sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, mainparent: typeMainParent[i]?._id, myAssigned: myAssignedSelected}, resolve ));
					});

					if (CUTVresult.docs.length > 0) {
						labeledDataArr.push(CUTVresult);
					}

					if(i == typeMainParent?.length -1 ){
						setLoader(false)
					}
				}
				if(!documentSelected){
					// if(otherresult?.docs?.length > 0){
					// 	setDocumentDetail(otherresult?.docs[0])
					// 	setSelectedDocument(otherresult?.docs[0]?._id)
					// } else {
						setDocumentDetail(labeledDataArr[0]?.docs[0])
						setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
					// }
				}
				setLabeledData(labeledDataArr);
				setLoader(false)
			// }))
		}))
		

	    }
		dispatch(set_archive_filter(status))
		dispatch(navigationAction(!navigationState));
	};


	const _getArchiveDocuments = async (status, doctype) => {
		//setStatus(JSON.parse(status))
		setIsArchived(true)
		setArchiveSelected(true)
		setDocInreview(false)
		setUnableToValidate(false)
		setOtherDocuments(false)
		setSelectedQuery("archive")
		setType("")
		setOtherDocs([])
		setOtherLabeledDocsData({})
		setReviewRequestedPage(1)
		setOtherDocsPage(1)
		setOtherLabeledDocsPage(1)
		setLabeledDocsPage(1)
		if(documentMenu?.docs?.length) {
			setLoader(true);
			setFilePage(pagination.page);
			dispatch(set_page(1));
			dispatch(getDocumentsByIdWithTypes({ folder: docId, limit: paginations, sort : sortByValue, order: order, fields: 'name', filter: keyWord, type : doctype ? doctype : type, deleted : status, unableToValidate: unableToValidate, otherDocuments: otherDocuments, docInreview: docInreview, myAssigned: myAssignedSelected}, ((result) => {
				dispatch({ type: "LIST_DOCUMENT", data: result?.review_requested?.docs, totalDocRecords: result.count, folder: docId });
			setElementPos(elementPos)
			setStatus(true);
			setLoader(true);
			setFilePage(pagination.page);
			dispatch(set_page(1));

			elementPos && elementPos != '' ? setsidebarActivePacketIndex(elementPos) : setsidebarActivePacketIndex(0)
				
				let docDta = folders.find(({ _id }) => _id === docId);
				setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
				setFolder(docDta && docDta?.type ? docDta?.type : {});
				console.log('JID 4')
				setDocumentList(result)
				setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
				setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
				// setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)


				let documentSelected = false
				dispatch(getAllReviewRequestedDocuments({folder: docId, sort: sortByValue, order: order, limit: 10, page: 1, deleted: true, filter: keyWord, fields: "name", myAssigned: myAssignedSelected}, async (reviewrequestedresult) => {
					if(reviewrequestedresult?.docs?.length > 0){
						documentSelected = true
					}
					setReviewRequestedData(reviewrequestedresult)
					setDocumentDetail(reviewrequestedresult?.docs[0])
					setSelectedDocument(reviewrequestedresult?.docs[0]?._id)

					dispatch(getAllOtherDocuments({folder: docId, sort: sortByValue, order: order, limit: 10, page: page, deleted: true, filter: keyWord, fields: "name",myAssigned: myAssignedSelected}, async (otherresult)=>{
						setOtherDocsData(otherresult)
						setOtherDocs(otherresult?.docs)

						// dispatch(getAllOtherLabeledDocuments({folder: docId, sort: sortByValue, order: order, limit: 10, page: page, deleted: true, filter: keyWord, fields: "name",myAssigned: myAssignedSelected}, async (otherlabeledresult)=>{
						// 	setOtherLabeledDocsData(otherlabeledresult)
						var labeledDataArr = [];
						for (let i = 0; i < typeMainParent.length; i++) {
							const labeledresult = await new Promise(resolve => {
								dispatch( getAllLabeledDocuments({folder: docId, sort: sortByValue, order: order, limit: 10, page: 1, deleted: true, filter: keyWord, fields: "name", mainparent: typeMainParent[i]?._id, myAssigned: myAssignedSelected}, resolve ));
							});
							if (labeledresult.docs.length > 0) {
								labeledDataArr.push(labeledresult);
							}

							const CUTVresult = await new Promise(resolve => {
								dispatch(getAllCUTVDocuments({folder: docId, sort: sortByValue, order: order, limit: 10, page: 1, deleted: true, filter: keyWord, fields: "name", mainparent: typeMainParent[i]?._id, myAssigned: myAssignedSelected}, resolve ));
							});
	
							if (CUTVresult.docs.length > 0) {
								labeledDataArr.push(CUTVresult);
							}
							if(i == typeMainParent?.length -1 ){
								setLoader(false)
							}
						}
						if(!documentSelected){
							if(otherresult?.docs?.length > 0){
								setDocumentDetail(otherresult?.docs[0])
								setSelectedDocument(otherresult?.docs[0]?._id)
							} else {
								setDocumentDetail(labeledDataArr[0]?.docs[0])
								setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
							}
						}
						setLabeledData(labeledDataArr);
					}))
					}))
				// }))
				
			})));
	    }
		// dispatch(set_archive_filter(status))
		dispatch(navigationAction(!navigationState));
	};



	/**
		 * @description method call to search documents from leftside bar listing 
		 * @param {*} val 
		 * @returns 
		 */


	const _advanceFilter = async (val, assignedval) => {
		let deleted = false
		setSortFn(0)  // to not trigger default sort fuctionality in filemenus component when desc/ asc is clicked
		setFileRefreshFlag(false);
		setFolderRefreshFlag(false);
		setFilePage(1);
		setReviewRequestedPage(1)
		setOtherDocsPage(1)
		setOtherLabeledDocsPage(1)
		setLabeledDocsPage(1)
		setType("")
		setKeyWord('')
		setSortByValue('createdAt')
		setSortByName('Date')
		setOrder('-1')
		setPage(1)
		setHasPrevPage(false)
		dispatch({ type: "UPDATE_FOLDER_LABEL", data: val });
		setFilterSelected(val)
		let advFilter = documentFilterItems[val]
		
		setLabel(advFilter?.label)
		// setValue(advFilter)
		if(advFilter?.label == "Archived")
		{
			deleted = true
			setIsArchived(true)
			delete payload?.is_correct;
			delete payload?.is_verified;
			delete payload?.deleted;
			dispatch(set_archive_filter(true))
			payload = { ...payload, ...advFilter, page: 1, sort: "updatedAt", order: -1, myAssigned: assignedval == false ? false : myAssignedSelected, deleted : deleted, filter: filter, fields: "name,loan_number"}
		    setLabelStatus("Archived")
			setSelectedQuery("archive")
			setStatus(true)
			setFilterPayload(payload)
		// }else if(advFilter?.label == "Completed"){
		// 	let allDocumentsAllActionCompleted = true
		// 	setIsArchived(true)
		// 	delete payload?.is_correct;
		// 	delete payload?.is_verified;
		// 	delete payload?.deleted;
		// 	// dispatch(set_archive_filter(true))
		// 	payload = { ...payload, ...advFilter, page: 1, sort: "updatedAt", order: -1, myAssigned: assignedval == false ? false : myAssignedSelected, allDocumentsAllActionCompleted : allDocumentsAllActionCompleted}
		// 	setLabelStatus("Completed")
		// 	setSelectedQuery("completed")
		// 	setStatus(true)
		// 	setFilterPayload(payload)
		}else{
			setIsArchived(false)
            setLabelStatus("")
			setSelectedQuery("")
			setStatus(false)
			dispatch(set_archive_filter(false))
			payload = { ...payload, ...advFilter, ...{ 'deleted':false }, page: 1, sort: "updatedAt", order: -1, myAssigned: assignedval == false ? false : myAssignedSelected, label: advFilter?.label ? advFilter.label : null, filter: filter, fields: "name,loan_number" }

            setFilterPayload(payload)
		}
		//setValue(payload)
		elasticPayload = { ...payload, ...advFilter }
		setElasticSearchList([]);
		setElasticPayload(elasticPayload);
		setPayload(payload);
		setInnerLoader(true);
		setsidebarActivePacketIndex(0)
		if (val?.trim()) {
			elasticPayload = { ...elasticPayload, name: val }
			setElasticPayload(elasticPayload)
			await dispatch(getElasticSearchFolders(elasticPayload, ((result) => {
				setInnerLoader(false);
				setElasticSearchList(result?.hits?.hits);
				setFocusSearchFlag(true);
			})));
		}
		dispatch(getDocumentsWithTypes(payload, ((result) => {
			setLoader(true)
			setTotalPages(result.totalPages)
			setInnerLoader(false);
			setTags(result.docs !== undefined && result.docs.length ? result.docs[0].tags : [])
			setFolder(documentMenu.docs[0]?.type);
			console.log('JID 5')
			setDocumentList(result?.docs[0]?.documents)

			let documentSelected = false;
			dispatch(getAllReviewRequestedDocuments({page: 1, folder: result?.docs[0]?._id, deleted: deleted, sort : 'createdAt', order: -1, fields: 'name', limit: 10, myAssigned: assignedval == false ? false : myAssignedSelected}, (reviewrequestedresult)=>{
				if(reviewrequestedresult?.docs?.length > 0 ){
					documentSelected = true
				}
				setReviewRequestedData(reviewrequestedresult)
				setDocumentDetail(reviewrequestedresult?.docs[0])
				setSelectedDocument(reviewrequestedresult?.docs[0]?._id)
				setReviewRequestedCount(reviewrequestedresult.totalDocs)

				// dispatch(getAllOtherDocuments({folder: result?.docs[0]?._id, limit: paginations, deleted: deleted, sort : sortByValue, order: order, fields: 'name', filter: keyWord,  limit: 10, myAssigned: assignedval == false ? false : myAssignedSelected}, (otherresult)=>{
				// 	setOtherDocs(otherresult.docs)
				// 	setOtherDocsCount(otherresult.totalDocs)

					dispatch(getMainParent({}, async (data)=>{
						setTypeMainParent(data)
						var labeledDataArr = [];
						var pages = {}
						for (let i = 0; i < data.length; i++) {
							const labeledresult = await new Promise(resolve => {
								dispatch(getAllLabeledDocuments({ folder: result?.docs[0]?._id, mainparent: data[i]?._id, limit: paginations, deleted: deleted, sort: 'updatedAt', order: -1, fields: 'name', limit: 10, myAssigned: assignedval == false ? false : myAssignedSelected }, resolve )); });
							if (labeledresult.docs.length > 0) {
								pages = {...pages, [data[i]?._id] : 1}
								labeledDataArr.push(labeledresult);
							}

							const CUTVresult = await new Promise(resolve => {
								dispatch(getAllCUTVDocuments({ folder: result?.docs[0]?._id, mainparent: data[i]?._id, limit: paginations, deleted: deleted, sort: 'updatedAt', order: -1, fields: 'name', limit: 10, myAssigned: assignedval == false ? false : myAssignedSelected }, resolve ));  
							});
	
							if (CUTVresult.docs.length > 0) {
								pages = {...pages, [data[i]?._id] : 1}
								labeledDataArr.push(CUTVresult);
							}
							if(i == typeMainParent?.length -1 ){
								setLoader(false)
							}
						}
						if(!documentSelected){
							// if(otherresult?.docs?.length > 0){
							// 	setDocumentDetail(otherresult?.docs[0])
							// 	setSelectedDocument(otherresult?.docs[0]?._id)
							// } else {
								setDocumentDetail(labeledDataArr[0]?.docs[0])
								setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
							// }
						}
						setLabeledDocsPage(pages)
						setLabeledData(labeledDataArr);
						if(result?.docs[0]?._id){
							_getDocumentTypes(result?.docs[0]?._id,deleted, assignedval == false ? false : myAssignedSelected)
						}else{
							dispatch(getDocumentTypes({ limit: pagination.maxlimit, deleted : false }, (res) => {
								res.tree[0].children[0].children[0].active = true
								res.tree[0].children[0].children[0].terminal = true
								let newdata = { ...dropData, children: res?.tree };
								setDropData(newdata);
								setLoader(false);
							}))
						}
					}))
				}))
			// }))


			// setDocumentDetail(result?.docs[0]?.documents?.review_requested?.docs[0] ? result?.docs[0]?.documents?.review_requested?.docs[0] : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0] : result?.docs[0]?.documents?.other_documents?.docs[0] ? result?.docs[0]?.documents?.other_documents?.docs[0] : {})
			// setSelectedDocument(result?.docs[0]?.documents?.review_requested?.docs[0]?._id ? result?.docs[0]?.documents?.review_requested?.docs[0]?._id : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0]?._id : result?.docs[0]?.documents?.other_documents?.docs[0]?._id ? result?.docs[0]?.documents?.other_documents?.docs[0]?._id : {})
			// setSelectedFileId(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0]?._id : null);
		})));

	}


		const refreshsssFiles = (docIndex) => {
		setReviewRequestedPage(1)
		setOtherDocsPage(1)
		setOtherLabeledDocsPage(1)
		setLabeledDocsPage(1)
		if(documentMenu?.docs?.length)
		{
			setElementPos(docIndex)
			setLoader(true);
			setFilePage(pagination.page);
			setDocId(docId);
			dispatch(set_page(1));
		 	let refreshsssFilespayload;
        //  if(labelStatus === 'Archived')
		//  {
        //      refreshsssFilespayload = { folder: docId, sort: sortByValue, order: order, limit: paginations, page: 1, fields: 'name', filter: keyWord, type : type, deleted :true }
		//      dispatch(set_archive_filter(true))
		//  }else
		//  {
             refreshsssFilespayload = { folder: docId, sort: sortByValue, order: order, limit: paginations, page: 1, fields: 'name', filter: keyWord, type : type, deleted : labelStatus != "Archived" ? archiveSelected : status, unableToValidate: unableToValidate, myAssigned: myAssignedSelected  }
		//  }
			// docIndex && docIndex != '' ? setsidebarActivePacketIndex(docIndex) : setsidebarActivePacketIndex(0)
			dispatch(getDocumentsByIdWithTypes(refreshsssFilespayload, ((result) => {
				// setLoader(false);
				let docDta = folders.find(({ _id }) => _id === docId);
				console.log('refresh files folder id : ', docDta)
				setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
				setFolder(docDta && docDta?.type ? docDta?.type : {});
				console.log('JID 6')
				setDocumentList(result)
				// setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
				// setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
				// setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)
			})));

			if(otherDocuments){
				dispatch(getAllOtherDocuments({...refreshsssFilespayload, otherDocuments: otherDocuments}, async (otherresult)=>{
					setOtherDocsData(otherresult)
					setOtherDocs(otherresult?.docs)
					setOtherDocsCount(otherresult?.totalDocs)
					dispatch(getAllOtherLabeledDocuments({...refreshsssFilespayload,otherDocuments: otherDocuments}, async (otherLabeledDocResult)=>{
						setOtherLabeledDocsData(otherLabeledDocResult)
						setLoader(false);
					}))
				}))
			}else{
				let documentSelected = false;	
				dispatch(getAllReviewRequestedDocuments(refreshsssFilespayload, async (result)=>{
					if(result?.docs?.length > 0){
						documentSelected = true
					}
					let docDta = folders.find(({ _id }) => _id === docId);
					setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
					setFolder(docDta && docDta?.type ? docDta?.type : {});
					setReviewRequestedData(result)
					setDocumentDetail(result?.docs[0])
					setSelectedDocument(result?.docs[0]?._id)
					setReviewRequestedCount(result.totalDocs)
	
					
					var labeledDataArr = [];
						let pages = {}
						for (let i = 0; i < typeMainParent.length; i++) {
							const labeledresult = await new Promise(resolve => {
							dispatch(
								getAllLabeledDocuments({...refreshsssFilespayload, mainparent: typeMainParent[i]?._id }, resolve)
							);
							});
							if (labeledresult.docs.length > 0) {
								pages = {...pages, [typeMainParent[i]?._id] : 1}
								labeledDataArr.push(labeledresult);
							}

							const CUTVresult = await new Promise(resolve => {
								dispatch(getAllCUTVDocuments({ ...refreshsssFilespayload, mainparent: typeMainParent[i]?._id }, resolve ));  
							});
	
							if (CUTVresult.docs.length > 0) {
								pages = {...pages, [typeMainParent[i]?._id] : 1}
								labeledDataArr.push(CUTVresult);
							}

							if(i == typeMainParent?.length -1 ){
								setLoader(false)
							}
						}
						if(!documentSelected){
								setDocumentDetail(labeledDataArr[0]?.docs[0])
								setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
						}
						setLabeledData(labeledDataArr);
						setLoader(false)
				}))
			}
			

	}
		dispatch(navigationAction(!navigationState));
	}

	const resetType = () =>{
		if(documentMenu?.docs?.length) {
			setSelectedQuery("")
			setType("")
			setFileRefreshFlag(false)

			if(labelStatus == "Archived"){
				setIsArchived(true)
				setStatus(true)
			}else{
				setIsArchived(false)
				setStatus(false)
			}
			setDocInreview(false)
			setUnableToValidate(false)
			setOtherDocuments(false)
			setElementPos(elementPos)
			
			setLoader(true);
			setFilePage(pagination.page);
			setDocId(docId);
			dispatch(set_page(1));
			setReviewRequestedPage(1)
			setOtherDocsPage(1)
			setOtherLabeledDocsPage(1)
			setLabeledDocsPage(1)

			console.log("dsdsdwewew", elementPos)
			elementPos && elementPos != '' ? setsidebarActivePacketIndex(elementPos) : setsidebarActivePacketIndex(0)

			// dispatch(getDocumentsByIdWithTypes({ folder: docId, limit: paginations, page: 1, sort: sortByValue, order : order, fields: 'name', filter: keyWord, deleted : false }, ((result) => {
				
			// 	let docDta = folders.find(({ _id }) => _id === docId);
			// 	setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			// 	setFolder(docDta && docDta?.type ? docDta?.type : {});
			// 	setDocumentList(result)
			// 	setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
			// 	setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")	
			// 	setLoader(false);
			// 	// setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)
			// })));		

			let documentSelected = false;	
			dispatch(getAllReviewRequestedDocuments({folder: docId, sort: sortByValue, order: order, limit: paginations, page: 1, deleted: status, filter: keyWord, fields: "name", myAssigned: myAssignedSelected}, async (result)=>{
				if(result?.docs?.length > 0){
					documentSelected = true
				}
				let docDta = folders.find(({ _id }) => _id === docId);
				setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
				setFolder(docDta && docDta?.type ? docDta?.type : {});
				setReviewRequestedData(result)
				setDocumentDetail(result?.docs[0])
				setSelectedDocument(result?.docs[0]?._id)
				setReviewRequestedCount(result.totalDocs)

				// dispatch(getAllOtherDocuments({folder: docId, sort: sortByValue, order: order, limit: paginations, page: 1, deleted: false, filter: keyWord, fields: "name",myAssigned: myAssignedSelected}, async (otherresult)=>{
				// 	setOtherDocsData(otherresult)
				// 	setOtherDocs(otherresult?.docs)
				// 	setOtherDocsCount(otherresult?.totalDocs)

					var labeledDataArr = [];
					let pages = {}
					for (let i = 0; i < typeMainParent.length; i++) {
						const labeledresult = await new Promise(resolve => {
						dispatch(
							getAllLabeledDocuments({folder: docId, sort: sortByValue, order: order, limit: paginations, page: 1, deleted: status, filter: keyWord, fields: "name", mainparent: typeMainParent[i]?._id, myAssigned: myAssignedSelected }, resolve)
						);
						});
						if (labeledresult.docs.length > 0) {
							pages = {...pages, [typeMainParent[i]?._id] : 1}
							labeledDataArr.push(labeledresult);
						}

						const CUTVresult = await new Promise(resolve => {
							dispatch(getAllCUTVDocuments({folder: docId, sort: sortByValue, order: order, limit: paginations, page: 1, deleted: status, filter: keyWord, fields: "name", mainparent: typeMainParent[i]?._id, myAssigned: myAssignedSelected }, resolve));  
						});

						if (CUTVresult.docs.length > 0) {
							pages = {...pages, [typeMainParent[i]?._id] : 1}
							labeledDataArr.push(CUTVresult);
						}

						if(i == typeMainParent?.length -1 ){
							setLoader(false)
						}
					}
					if(!documentSelected){
						// if(otherresult?.docs?.length > 0){
						// 	setDocumentDetail(otherresult?.docs[0])
						// 	setSelectedDocument(otherresult?.docs[0]?._id)
						// } else {
							setDocumentDetail(labeledDataArr[0]?.docs[0])
							setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
						// }
					}
					setLabeledData(labeledDataArr);
					_getDocumentTypes(docId, status)
				// }))
			}))
		}
		dispatch(navigationAction(!navigationState));
	}


	const getUnableToValidate = () =>{
		setType("")
		if(documentMenu?.docs?.length)
		{
		setSelectedQuery("unable_to_validate")
		setDocInreview(false)
		setUnableToValidate(true)
		setOtherDocuments(false)
		setElementPos(elementPos)
		setLoader(true);
		setFilePage(pagination.page);
		setDocId(docId);
		setReviewRequestedPage(1)
		dispatch(set_page(1));
		setOtherDocs([])
		if(labelStatus == "Archived"){
			setStatus(true)
			setIsArchived(true)
		}else{
			setStatus(false)
			setIsArchived(false)
		}
		setOtherLabeledDocsData({})
		setReviewRequestedPage(1)
		setOtherDocsPage(1)
		setOtherLabeledDocsPage(1)
		setLabeledDocsPage(1)
		elementPos && elementPos != '' ? setsidebarActivePacketIndex(elementPos) : setsidebarActivePacketIndex(0)

		// dispatch(getDocumentsByIdWithTypes({ folder: docId, limit: paginations, page: 1, fields: 'name', deleted: status, filter: keyWord, unableToValidate : true }, ((result) => {
		// 	if(result.count == 0){
		// 		dispatch(getDocumentsByIdWithTypes({ folder: docId, limit: paginations, page: 1, fields: 'name', deleted: false, filter: keyWord, unableToValidate : true }, ((result) => { 
		// 			setStatus(false)
		// 			setLoader(false);
		// 			let docDta = folders.find(({ _id }) => _id === docId);
		// 			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
		// 			setFolder(docDta && docDta?.type ? docDta?.type : {});
		// 			setDocumentList(result)
		// 			setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
		// 			setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
		// 		})))
		// 	}else{
		// 		setLoader(false);
		// 		let docDta = folders.find(({ _id }) => _id === docId);
		// 		setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
		// 		setFolder(docDta && docDta?.type ? docDta?.type : {});
		// 		setDocumentList(result)
		// 		setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
		// 		setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
		// 	}
			
		// 	// setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)
		// })));
		setOtherDocsData({})
		// setLabeledData([])
		let documentSelected = false;
		dispatch(getAllReviewRequestedDocuments({ deleted : status,sort : sortByValue, order : order, folder: docId, limit: paginations, page: 1, fields: 'name', filter: keyWord, unableToValidate : true, myAssigned: myAssignedSelected }, async (result)=>{
			if(result?.docs?.length){
				documentSelected = true
			}
			setReviewRequestedData(result)
			setOtherDocs([])
			setDocumentDetail(result?.docs[0])
			setSelectedDocument(result?.docs[0]?._id)
			// setReviewRequestedCount(result.totalDocs)
			
			var labeledDataArr = [];
			let pages = {}
			for (let i = 0; i < typeMainParent.length; i++) {
				const labeledresult = await new Promise(resolve => {
				dispatch(
					getAllLabeledDocuments({ folder: docId, limit: paginations, page: 1, fields: 'name', filter: keyWord, unableToValidate : true ,mainparent: typeMainParent[i]?._id, myAssigned: myAssignedSelected, deleted: status }, resolve)
				);
				});
				if (labeledresult.docs.length > 0) {
					pages = {...pages, [typeMainParent[i]?._id] : 1}
					labeledDataArr.push(labeledresult);
				}

				const CUTVresult = await new Promise(resolve => {
					dispatch(getAllCUTVDocuments({ folder: docId, limit: paginations, page: 1, fields: 'name', filter: keyWord, unableToValidate : true ,mainparent: typeMainParent[i]?._id, myAssigned: myAssignedSelected, deleted: status }, resolve));
				});

				if (CUTVresult.docs.length > 0) {
					pages = {...pages, [typeMainParent[i]?._id] : 1}
					labeledDataArr.push(CUTVresult);
				}

				if(i == typeMainParent?.length -1 ){
					setLoader(false)
				}
			}
			if(!documentSelected){
				setDocumentDetail(labeledDataArr[0]?.docs[0])
				setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
			}
			setLabeledData(labeledDataArr);
		}))


	}
		dispatch(navigationAction(!navigationState));
	}

	const getDocInNeedOfReview = () =>{
		setType("")
		setOtherDocs([])
		setLabeledData([])
		setOtherLabeledDocsData({})
		setReviewRequestedPage(1)
		if(documentMenu?.docs?.length)
		{
		setSelectedQuery("doc_in_review")
		setDocInreview(true)
		setUnableToValidate(false)
		setOtherDocuments(false)
		setElementPos(elementPos)
		setLoader(true);
		setFilePage(pagination.page);
		setDocId(docId);
		dispatch(set_page(1));
		if(labelStatus == "Archived"){
			setStatus(true)
			setIsArchived(true)
		}else{
			setStatus(false)
			setIsArchived(false)
		}
		elementPos && elementPos != '' ? setsidebarActivePacketIndex(elementPos) : setsidebarActivePacketIndex(0)

		dispatch(getDocumentsByIdWithTypes({ folder: docId, limit: paginations, page: 1, fields: 'name', deleted: status, filter: keyWord, docInreview : true }, ((result) => {
			if(result.count == 0){
				dispatch(getDocumentsByIdWithTypes({ folder: docId, limit: paginations, page: 1, fields: 'name', deleted: status, filter: keyWord, docInreview : true }, ((result) => {
					if(labelStatus == "Archived"){
						setStatus(true)
					}else{
						setStatus(false)
					}
					let docDta = folders.find(({ _id }) => _id === docId);
					setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
					setFolder(docDta && docDta?.type ? docDta?.type : {});
					console.log('JID 7')
					setDocumentList(result)
					setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
					setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
				})))
			}else{
				
				let docDta = folders.find(({ _id }) => _id === docId);
				setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
				setFolder(docDta && docDta?.type ? docDta?.type : {});
				console.log('JID 8')
				setDocumentList(result)
				setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
				setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
			}
			
			// setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)
		})));
		dispatch(getAllReviewRequestedDocuments({folder: docId,sort : sortByValue, order : order, limit: paginations, page: 1, fields: 'name', deleted: status, filter: keyWord, docInreview : true, myAssigned: myAssignedSelected}, (result)=>{
			setReviewRequestedData(result)
			setDocumentDetail(result?.docs[0])
			setSelectedDocument(result?.docs[0]?._id)
			// setReviewRequestedCount(result.totalDocs)
			setLoader(false);
		}))

	}
		dispatch(navigationAction(!navigationState));
	}

	const getOtherDocuments = () =>{
		setOtherDocuments(true)
		setType("")
		if(documentMenu?.docs?.length) {
			setSelectedQuery("other_documents")
			setUnableToValidate(false)
			setDocInreview(false)
			setElementPos(elementPos)
			setLoader(true);
			setFilePage(pagination.page);
			setDocId(docId);
			setReviewRequestedPage(1)
			setOtherDocsPage(1)
			setOtherLabeledDocsPage(1)
			dispatch(set_page(1));
			setReviewRequestedData([])
			setLabeledData([])
			if(labelStatus == "Archived"){
				setIsArchived(true)
				setStatus(true)
			}
			else{
				setIsArchived(false)
				setStatus(false)
			}
			elementPos && elementPos != '' ? setsidebarActivePacketIndex(elementPos) : setsidebarActivePacketIndex(0)
			// dispatch(getDocumentsByIdWithTypes({ folder: docId, limit: paginations, page: 1, fields: 'name', deleted: status, filter: keyWord, otherDocuments : true }, ((result) => {
			// 	if(!result.count){
			// 		dispatch(getDocumentsByIdWithTypes({ folder: docId, limit: paginations, page: 1, fields: 'name', deleted: false, filter: keyWord, otherDocuments : true }, ((result) => { 
			// 			setStatus(false)
			// 			setLoader(false);
			// 			let docDta = folders.find(({ _id }) => _id === docId);
			// 			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			// 			setFolder(docDta && docDta?.type ? docDta?.type : {});
			// 			setDocumentList(result)
			// 			setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
			// 			setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
			// 		})))
			// 	}else{
			// 		setLoader(false);
			// 		let docDta = folders.find(({ _id }) => _id === docId);
			// 		setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			// 		setFolder(docDta && docDta?.type ? docDta?.type : {});
			// 		setDocumentList(result)
			// 		setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
			// 		setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id :"")
			// 	}
			// 	// setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)
			// })));
				let documentSelected = false;
				dispatch(getAllOtherDocuments({deleted : status,folder: docId, limit: paginations, page: 1, fields: 'name', filter: keyWord, otherDocuments : true, myAssigned: myAssignedSelected}, (otherresult)=>{
					
					if(otherresult?.docs?.length > 0){
						documentSelected = true;
						setDocumentDetail(otherresult?.docs[0])
						setSelectedDocument(otherresult?.docs[0]?._id)
					}
					
				
					let docDta = folders.find(({ _id }) => _id === docId);
					setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
					setFolder(docDta && docDta?.type ? docDta?.type : {});
					setOtherDocsData(otherresult)
					setOtherDocs(otherresult.docs)
					setOtherDocsCount(otherresult.totalDocs)
					
					dispatch(getAllOtherLabeledDocuments({deleted : status, folder: docId, limit: paginations, page: 1, fields: 'name', filter: keyWord, otherDocuments : true, myAssigned: myAssignedSelected}, (otherlabeledresult)=>{
						setLoader(false)
						setOtherLabeledDocsData(otherlabeledresult);

						console.log('documentSelected',documentSelected,otherlabeledresult?.docs[0])

						if(!documentSelected){
							setDocumentDetail(otherlabeledresult?.docs[0])
							setSelectedDocument(otherlabeledresult?.docs[0]?._id)
						}
						// setDocumentDetail(otherlabeledresult?.docs[0])
						// setSelectedDocument(otherlabeledresult?.docs[0]?._id)
						// setFolder(docDta && docDta?.type ? docDta?.type : {});
						// setOtherDocsData(otherresult)
						// setOtherDocs(otherresult.docs)
						// setOtherDocsCount(otherresult.totalDocs)
						
					}))
	
				}))

			
	}
		dispatch(navigationAction(!navigationState));
	}
	/**const CustomHeader = (props) => {
		return (
			<div style={{
				fontWeight: `${props.node.children?.length ? 'bold' : ''}`,
				fontSize: 12
			}}
				className={`${props.node.children?.length ? 'sd-header' : 'sd-childs'}`}>
				{props.node.name}
			</div>
		);
	}

	const onClick = (value) => {
		setIsComponentVisible(true)
		const filter = value?.trim();
		decorators.Header = CustomHeader
		defaultTheme.tree.node.activeLink.background = 'red';
	 * @description method call to search documents from leftside bar listing 
	 * @param {*} val 
	 * @returns 
	 */

	const __advanceFilter = async (sortBy, order, val, assignedval, resetLabel = false)   => {
		setSortFn(1)  // to not trigger default sort fuctionality in filemenus component when desc/ asc is clicked
		setFileRefreshFlag(false);
		setFolderRefreshFlag(false);
		setFilePage(1);
		setPage(1);
		setReviewRequestedPage(1)
		setOtherDocsPage(1)
		setOtherLabeledDocsPage(1)
		setSortByValue(sortBy);
		setOrder(order)
		setSortByName('Date');

		
		let documentFilter = resetLabel  ? null :  documentFilterItems[filterSelected];  // in case of reset label , is_correct, is_verified should be null
        if(resetLabel){
			setLabel('');
			setKeyWord('');
			setElasticSearchList([]);
			setElasticPayload({});
		}
		payload = { ...payload, ...{ 'deleted':status === true?false:status}, docFilter: resetLabel ? "" : keyWord, sort: sortBy, order: order, page: 1, myAssigned: assignedval == false ? false : myAssignedSelected, label: documentFilter?.label, is_correct: documentFilter?.is_correct, is_verified: documentFilter?.is_verified, filter: resetLabel ? '' : filter, fields: "name,loan_number"}
		setPayload(payload);
		setInnerLoader(true);
		setsidebarActivePacketIndex(0)
		setOtherLabeledDocsData({})
		setOtherDocs([])
		setLoader(true)
		dispatch({ type: "UPDATE_FOLDER_SORT", data: val });
		setSortBySelected(val)
		// dispatch(getDocuments(payload, ((result) => {
		// 	setInnerLoader(false);
		// 	setTags(result.docs !== undefined && result.docs.length ? result.docs[0].tags : [])
		// 	setFolder(documentMenu.docs[0]?.type);
		// 	setDocumentDetail(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0] : {})
		// 	setSelectedFileId(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0]?._id : null);
		// })));

		dispatch(getDocumentsWithTypes(payload, ((result) => { // for default folders filter
			setInnerLoader(false)
			setTotalPages(result.totalPages)
			setHasNextPage(result.hasNextPage)
			setHasPrevPage(result.hasPrevPage)
			let docDta = folders.find(({ _id }) => _id === docId);
			
			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			setFolder(docDta && docDta?.type ? docDta?.type : {});
	
			let documentSelected = false;
			dispatch(getAllReviewRequestedDocuments({folder: result?.docs[0]?._id, limit: paginations, deleted: status, sort : sortByValue, order: order, fields: 'name', filter: resetLabel ? '' : keyWord, label:labelStatus, limit: 10, myAssigned: assignedval == false ? false : myAssignedSelected}, (reviewrequestedresult)=>{
				if(reviewrequestedresult?.docs?.length > 0 ){
					documentSelected = true
				}
				setReviewRequestedData(reviewrequestedresult)
				setDocumentDetail(reviewrequestedresult?.docs[0])
				setSelectedDocument(reviewrequestedresult?.docs[0]?._id)
				setReviewRequestedCount(reviewrequestedresult.totalDocs)

				// dispatch(getAllOtherDocuments({folder: result?.docs[0]?._id, limit: paginations, deleted: status, sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, myAssigned: assignedval == false ? false : myAssignedSelected}, (otherresult)=>{
				// 	setOtherDocsData(otherresult)
				// 	setOtherDocs(otherresult.docs)
				// 	setOtherDocsCount(otherresult.totalDocs)

					dispatch(getMainParent({}, async (data)=>{
						setTypeMainParent(data)
						var labeledDataArr = [];
						var pages = {}
						for (let i = 0; i < data.length; i++) {
							const labeledresult = await new Promise(resolve => {
								dispatch(getAllLabeledDocuments({ folder: result?.docs[0]?._id, mainparent: data[i]?._id, limit: paginations, deleted: status, sort: sortByValue, order: order, fields: 'name', filter: resetLabel ? '' : keyWord, label: labelStatus, limit: 10, myAssigned: assignedval == false ? false : myAssignedSelected }, resolve )); });
							if (labeledresult.docs.length > 0) {
								pages = {...pages, [data[i]?._id] : 1}
								labeledDataArr.push(labeledresult);
							}

							const CUTVresult = await new Promise(resolve => {
								dispatch(getAllCUTVDocuments({ folder: result?.docs[0]?._id, mainparent: data[i]?._id, limit: paginations, deleted: status, sort: sortByValue, order: order, fields: 'name', filter: resetLabel ? '' : keyWord, label: labelStatus, limit: 10, myAssigned: assignedval == false ? false : myAssignedSelected }, resolve ));
							});
	
							if (CUTVresult.docs.length > 0) {
								pages = {...pages, [data[i]?._id] : 1}
								labeledDataArr.push(CUTVresult);
							}
							if(i == data?.length -1 ){
								setLoader(false)
							}
						}
						setLabeledDocsPage(pages)
						setLabeledData(labeledDataArr);
						if(result?.docs[0]?._id){
							_getDocumentTypes(result?.docs[0]?._id, status, assignedval == false ? false : myAssignedSelected)
						}else{
							dispatch(getDocumentTypes({ limit: pagination.maxlimit, deleted : false }, (res) => {
								res.tree[0].children[0].children[0].active = true
								res.tree[0].children[0].children[0].terminal = true
								let newdata = { ...dropData, children: res?.tree };
								setDropData(newdata);
								setLoader(false);
							}))
						}
					}))
				}))
			// }))

			console.log('JID 9')
			setDocumentList(result?.docs[0]?.documents)
			// setDocumentDetail(result?.docs[0]?.documents?.review_requested?.docs[0] ? result?.docs[0]?.documents?.review_requested?.docs[0] : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0] : result?.docs[0]?.documents?.other_documents?.docs[0] ? result?.docs[0]?.documents?.other_documents?.docs[0] : {})

			// setSelectedDocument(result?.docs[0]?.documents?.review_requested?.docs[0]?._id ? result?.docs[0]?.documents?.review_requested?.docs[0]?._id : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0]?._id : result?.docs[0]?.documents?.other_documents?.docs[0]?._id ? result?.docs[0]?.documents?.other_documents?.docs[0]?._id : {})
			
		})));
	}

	const _myAssignedFilter = async (val) => {
		setMyAssignedSelected(val)
		setSortFn(1)  // to not trigger default sort fuctionality in filemenus component when desc/ asc is clicked
		setFileRefreshFlag(false);
		setFolderRefreshFlag(false);
		setFilePage(1);
		setReviewRequestedPage(1)
		setOtherDocsPage(1)
		setOtherLabeledDocsPage(1)
		setLabeledDocsPage(1)
		setSortByName('Date');
		setReviewRequestedData([])
		setLabeledData([])
		setOtherDocs([])
		setOtherLabeledDocsData({})
		setType("")
		setFilterSelected("")
		setLabel("")
		dispatch({ type: "UPDATE_DOCUMENT_FILTER", data: '' });
		// dispatch({ type: "UPDATE_FOLDER_LABEL", data: 4 });
		// dispatch({ type: "UPDATE_FOLDER_SORT", data: 2 });
		// let advFilter = documentFilterItems[filterSelected]
		let myAssignedpayload = { ...{ 'deleted':status === true?false:status}, docFilter: keyWord, sort: sortByValue, order: order, page: 1, myAssigned: val, limit: 10 }
		// console.log("dsadsadasdwew", payload, advFilter, keyWord)
		// payload = { ...payload, ...advFilter, ...{ 'deleted':status === true?false:status}, docFilter: keyWord, sort: sortByValue, order: order, page: 1, myAssigned: val }
		setPayload(myAssignedpayload);
		setInnerLoader(true);
		setsidebarActivePacketIndex(0)
		// dispatch(getDocuments(payload, ((result) => {
		// 	setInnerLoader(false);
		// 	setTags(result.docs !== undefined && result.docs.length ? result.docs[0].tags : [])
		// 	setFolder(documentMenu.docs[0]?.type);
		// 	setDocumentDetail(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0] : {})
		// 	setSelectedFileId(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0]?._id : null);
		// })));
		dispatch(getDocumentsWithTypes(myAssignedpayload, ((result) => { // for default folders filter
			setInnerLoader(false)
			setTotalPages(result.totalPages)
			setHasNextPage(result.hasNextPage)
			setHasPrevPage(result.hasPrevPage)
			let docDta = folders.find(({ _id }) => _id === docId);
			
			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			setFolder(docDta && docDta?.type ? docDta?.type : {});
	
			let documentSelected = false;
			dispatch(getAllReviewRequestedDocuments({folder: result?.docs[0]?._id, limit: paginations, deleted: status, sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, myAssigned: val}, (reviewrequestedresult)=>{
				if(reviewrequestedresult?.docs?.length > 0 ){
					documentSelected = true
				}
				setReviewRequestedData(reviewrequestedresult)
				setDocumentDetail(reviewrequestedresult?.docs[0])
				setSelectedDocument(reviewrequestedresult?.docs[0]?._id)
				setReviewRequestedCount(reviewrequestedresult.totalDocs)

				// dispatch(getAllOtherDocuments({folder: result?.docs[0]?._id, limit: paginations, deleted: status, sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, limit: 10, myAssigned: val}, (otherresult)=>{
				// 	setOtherDocsData(otherresult)
				// 	setOtherDocs(otherresult.docs)
				// 	setOtherDocsCount(otherresult.totalDocs)

					dispatch(getMainParent({}, async (data)=>{
						setTypeMainParent(data)
						var labeledDataArr = [];
						var pages = {}
						for (let i = 0; i < data.length; i++) {
							const labeledresult = await new Promise(resolve => {
								dispatch(getAllLabeledDocuments({ folder: result?.docs[0]?._id, mainparent: data[i]?._id, limit: paginations, deleted: status, sort: sortByValue, order: order, fields: 'name', filter: keyWord, label: labelStatus, limit: 10, myAssigned: val }, resolve )); });
							if (labeledresult.docs.length > 0) {
								pages = {...pages, [data[i]?._id] : 1}
								labeledDataArr.push(labeledresult);
							}

							const CUTVresult = await new Promise(resolve => {
								dispatch(getAllCUTVDocuments({ folder: result?.docs[0]?._id, mainparent: data[i]?._id, limit: paginations, deleted: status, sort: sortByValue, order: order, fields: 'name', filter: keyWord, label: labelStatus, limit: 10, myAssigned: val }, resolve ));  
							});
	
							if (CUTVresult.docs.length > 0) {
								pages = {...pages, [data[i]?._id] : 1}
								labeledDataArr.push(CUTVresult);
							}
							if(i == data?.length -1 ){
								setLoader(false)
							}
						}
						if(!documentSelected){
							// if(otherresult?.docs?.length > 0){
							// 	setDocumentDetail(otherresult?.docs[0])
							// 	setSelectedDocument(otherresult?.docs[0]?._id)
							// } else {
								setDocumentDetail(labeledDataArr[0]?.docs[0])
								setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
							// }
						}
						setLabeledDocsPage(pages)
						setLabeledData(labeledDataArr);
						if(result?.docs[0]?._id){
							_getDocumentTypes(result?.docs[0]?._id, status, val)
						}else{
							dispatch(getDocumentTypes({ limit: pagination.maxlimit, deleted : false }, (res) => {
								res.tree[0].children[0].children[0].active = true
								res.tree[0].children[0].children[0].terminal = true
								let newdata = { ...dropData, children: res?.tree };
								setDropData(newdata);
								setLoader(false);
							}))
						}
					}))
				}))
			// }))

			setDocumentList(result?.docs[0]?.documents)
			// setDocumentDetail(result?.docs[0]?.documents?.review_requested?.docs[0] ? result?.docs[0]?.documents?.review_requested?.docs[0] : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0] : result?.docs[0]?.documents?.other_documents?.docs[0] ? result?.docs[0]?.documents?.other_documents?.docs[0] : {})

			// setSelectedDocument(result?.docs[0]?.documents?.review_requested?.docs[0]?._id ? result?.docs[0]?.documents?.review_requested?.docs[0]?._id : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0]?._id : result?.docs[0]?.documents?.other_documents?.docs[0]?._id ? result?.docs[0]?.documents?.other_documents?.docs[0]?._id : {})
			
		})));
	}

	/**
	 * @description method call to search documents from leftside bar listing 
	 * @param {*} val 
	 * @returns 
	 */
	const _docSearch = async (val, moreInfoObj) => {
		const documentFilter = documentFilterItems[filterSelected];
		let filterWord = moreInfoObj && moreInfoObj.keyword ? moreInfoObj.keyword : val
		if(labelStatus == "Archived"){
			setIsArchived(true)
			setStatus(true)
		}else{
			setIsArchived(false)
			setStatus(false)
		}
        setFilePage(1);
        setPage(1);
        setInnerLoader(true);
        setSearch(filterWord);
		dispatch({ type: "UPDATE_DOCUMENT_FILTER", data: filterWord });
        // setSortByValue('createdAt');
        setSortByName('Date');
        // setOrder('-1');
        setsidebarActivePacketIndex(0)

		const {sort, order} = getSortParams(sortBySelected);

        payload = { ...payload, myAssigned: myAssignedSelected, fields: "name,loan_number", filter: filterWord, docFilter: keyWord, page: 1, label: documentFilter?.label, sort: sort, order: order, is_correct: documentFilter?.is_correct, is_verified: documentFilter?.is_verified  }
        setPayload(payload)
        // dispatch(getDocuments(payload, ((result) => {
        //     setInnerLoader(false);
        //     if (moreInfoObj && moreInfoObj !== undefined && moreInfoObj._id && moreInfoObj._id != '' && result.docs !== undefined && result.docs.length) {

        //         let elementPos = result.docs.map(function (doc) { return doc._id; }).indexOf(moreInfoObj._id);
        //         if (elementPos && elementPos !== -1) _handleSelected(moreInfoObj._id, elementPos);
        //     }

        // })));
		setOtherDocs([])
		setOtherLabeledDocsData({})

		dispatch(getDocumentsWithTypes(payload, ((result) => { // for default folders filter
			setInnerLoader(false)
			setTotalPages(result.totalPages)
			setHasNextPage(result.hasNextPage)
			setHasPrevPage(result.hasPrevPage)
			let docDta = folders.find(({ _id }) => _id === docId);
			if(result?.docs[0]?._id){
				_getDocumentTypes(result?.docs[0]?._id)
			}else{
				setLoader(false)
			}
			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			setFolder(docDta && docDta?.type ? docDta?.type : {});
			if (moreInfoObj && moreInfoObj !== undefined && moreInfoObj._id && moreInfoObj._id != '' && result.docs !== undefined && result.docs.length) {
                let elementPos = result.docs.map(function (doc) { return doc._id; }).indexOf(moreInfoObj._id);
				_handleSelected(moreInfoObj?._id, elementPos);
            } else {
				_handleSelected(result?.docs[0]?._id, 0);
			}
			
			// setDocumentDetail(result?.docs[0]?.documents?.review_requested?.docs[0] ? result?.docs[0]?.documents?.review_requested?.docs[0] : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0] : result?.docs[0]?.documents?.other_documents?.docs[0] ? result?.docs[0]?.documents?.other_documents?.docs[0] : {})

			// setSelectedDocument(result?.docs[0]?.documents?.review_requested?.docs[0]?._id ? result?.docs[0]?.documents?.review_requested?.docs[0]?._id : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0]?._id : result?.docs[0]?.documents?.other_documents?.docs[0]?._id ? result?.docs[0]?.documents?.other_documents?.docs[0]?._id : {})
			
		})));
	};

	/**
	* @description funnction call to search value by elasticsearc
	* @param {string} param search value
	 */

	const currentSearchRef = useRef('');

	const _elasticSearch = async (val) => {
		if (val.trim()) {
		  currentSearchRef.current = val;
		  elasticPayload = { ...elasticPayload, myAssigned: myAssignedSelected, name: val}
		  setElasticPayload(elasticPayload)
		  await dispatch(getElasticSearchFolders(elasticPayload, ((result) => {
			setInnerLoader(false);
			let results = result?.hits?.hits.filter((item) => {
			  if (item?._source?.ml_status == true) {
				return item
			  }
			})
			
			// Only update if this is still the current search
			if (val === currentSearchRef.current) {
			  setElasticSearchList(results);
			}
			setFocusSearchFlag(true);
		  })));
		} else {
		  currentSearchRef.current = '';
		  setElasticSearchList([])
		}
	  };

	const _selectedDoc = async (id) => {
		setLoader(true);
		setSelectedFileId(id);
		const doc = await documentList.find(({ _id }) => _id === id);
		setDocumentDetail(doc);
		setSelectedDocument(doc?._id)
		setLoader(false);
	};

	const _sortBySelected = async (val) => {
		setSortBySelected(val);

	};


	const _filterSelected = async (val) => {
		setFilterSelected(val);
	};

	const _myAssignedSelected = async (val) => {
		setMyAssignedSelected(val);
	};
	
	/**
	 * @description method call to loadmore folders in leftside bar listing 
	 * @param {*} activePage 
	 * @returns 
	 */

	const _handlePageChange = (activePage) => {
		setPage(activePage);
		setInnerLoader(true)
		setSidebarLoading(true);
		setSidebarLoadingLabel('loading');
		setOtherDocuments(false)
		const documentFilter = documentFilterItems[filterSelected];
		const {sort, order} = getSortParams(sortBySelected);
		payload = { ...payload,  page: activePage, docFilter: keyWord, order: order, sort: sort,label: documentFilter?.label ? documentFilter.label : label, myAssigned: myAssignedSelected, is_correct: documentFilter?.is_correct, is_verified: documentFilter?.is_verified, filter: filter, fields: "name,loan_number"}
		setPayload(payload);
		setType("")
		setOtherDocs([])
		setOtherLabeledDocsData({})
		setTypeSelected("");
		setTypeSelectedChild("");
		setTypeSelectedParent("");
		setTypeSelectedGrandParent("");
		let documentSelected = false;
		dispatch(getDocumentsWithTypes(payload, ((result) => {
			setInnerLoader(false)
			setTotalPages(result.totalPages)
			setLoader(true)
			_handleSelected(result?.docs[0]?._id)
			dispatch(getAllReviewRequestedDocuments({deleted : status,folder: result?.docs[0]?._id, limit: 10,  sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, myAssigned: myAssignedSelected}, async (reviewrequestedresult)=>{
				if(reviewrequestedresult?.docs?.length > 0){
					documentSelected = true
				}
				setReviewRequestedData(reviewrequestedresult)
				setSelectedDocument(reviewrequestedresult?.docs[0]?._id)
				setDocumentDetail(reviewrequestedresult?.docs[0])
				setReviewRequestedCount(reviewrequestedresult?.totalDocs)
				
				// dispatch(getAllOtherDocuments({folder: result?.docs[0]?._id, limit: 10, sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, myAssigned: myAssignedSelected}, async (otherresult)=>{
				// 	setOtherDocsData(otherresult)
				// 	setOtherDocs(otherresult?.docs)
				// 	setOtherDocsCount(otherresult?.totalDocs)

					var labeledDataArr = [];
					for (let i = 0; i < typeMainParent.length; i++) {
						const labeledresult = await new Promise(resolve => {
							dispatch( getAllLabeledDocuments({deleted : status,folder: result?.docs[0]?._id, limit: 10, mainparent: typeMainParent[i]?._id, sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, myAssigned: myAssignedSelected}, resolve ));
						});
						if (labeledresult.docs.length > 0) {
							labeledDataArr.push(labeledresult);
						}

						const CUTVresult = await new Promise(resolve => {
							dispatch(getAllCUTVDocuments({deleted : status,folder: result?.docs[0]?._id, limit: 10, mainparent: typeMainParent[i]?._id, sort : sortByValue, order: order, fields: 'name', filter: keyWord, label:labelStatus, myAssigned: myAssignedSelected}, resolve ));
						});

						if (CUTVresult.docs.length > 0) {
							labeledDataArr.push(CUTVresult);
						}
						if(i == typeMainParent?.length -1 ){
							setLoader(false)
						}
					}
					if(!documentSelected){
						// if(otherresult?.docs?.length > 0){
						// 	setDocumentDetail(otherresult?.docs[0])
						// 	setSelectedDocument(otherresult?.docs[0]?._id)
						// } else {
							setDocumentDetail(labeledDataArr[0]?.docs[0])
							setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
						// }
					}
					setLabeledData(labeledDataArr);
			}))
		// }))
			
			setsidebarActivePacketIndex(0)
			setHasNextPage(result?.hasNextPage)
			setHasPrevPage(result?.hasPrevPage)
			setSidebarLoading(false);
			setSidebarLoadingLabel('View More');
		})));
	}

	const _resetFilter = () => {
		setLoader(true)
		setFileRefreshFlag(false);
		setFolderRefreshFlag(false);
		setStatus(false)
		setFileSearch(false)
		setKeyWord('');
		setFilePage(1);
		setPage(1);
		setElasticSearchList([]);
		setFocusSearchFlag(false);
		setMyAssignedSelected(false)
		// setSortByValue('createdAt');
		setSortByName('Date');
		// setOrder('-1');
		payload = { limit: paginations, page: 1, sort: 'updatedAt', order: -1, deleted : status === true ? false : status, myAssigned: false }
		setPayload(payload);
		setElasticPayload({});
		setInnerLoader(true);
		dispatch({ type: "UPDATE_DOCUMENT_FILTER", data: '' });
		dispatch({ type: "UPDATE_FOLDER_LABEL", data: '' });
		dispatch({ type: "UPDATE_FOLDER_SORT", data: '' });
		setFilterSelected(null)
		setSortBySelected(null)
		setSearch('')
		setsidebarActivePacketIndex(0)
		setOtherDocs([])
		setOtherLabeledDocsData({})
		dispatch(getDocumentsWithTypes({...payload, myAssigned: false}, ((result) => {
			setInnerLoader(false);
			setTotalPages(result.totalPages)
			setTags(result.docs !== undefined && result.docs.length ? result.docs[0].tags : [])
			setFolder(documentMenu.docs[0]?.type);
			console.log('JID 11')
			setDocumentList(result?.docs[0]?.documents)
			setDocumentDetail(result?.docs[0]?.documents?.review_requested?.docs[0] ? result?.docs[0]?.documents?.review_requested?.docs[0] : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0] : result?.docs[0]?.documents?.other_documents?.docs[0] ? result?.docs[0]?.documents?.other_documents?.docs[0] : {})
			setSelectedDocument(result?.docs[0]?.documents?.review_requested?.docs[0]?._id ? result?.docs[0]?.documents?.review_requested?.docs[0]?._id : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0]?._id : result?.docs[0]?.documents?.other_documents?.docs[0]?._id ? result?.docs[0]?.documents?.other_documents?.docs[0]?._id : {})
			if(result?.docs[0]?._id){
				_getDocumentTypes(result?.docs[0]?._id, status, false)
			}else{
				setLoader(false)
			}
			// setDocumentDetail(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0] : {})
			// setSelectedDocument(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0]?._id : {})
			// setSelectedFileId(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0]?._id : null);

		})));


	}

	/**
	 * @description method call to loadmore document files 
	 * @param {*} activePage 
	 * @returns 
	 */

	const _handleFilePageChange = (activePage) => {
		//dispatch(pageLimit(activePage))
		setFilePage(activePage);
		dispatch(set_page(activePage));
		setFileLoading(true);
		setFileLoadingLabel('loading');
		dispatch(appendDocumentsById({ folder: docId, sort: sortByValue, order: order, fields: "name", filter: '', limit: paginations, page: activePage, deleted: status, myAssigned: myAssignedSelected }, ((result) => {
			setFileLoading(false);
			setFileLoadingLabel('View More');
		})));

	}


	/**
	 * @description method call to refresh document files 
	 * @param {*} activePage 
	 * @returns 
	 */

	const refreshFiles = () => {
		setFileRefreshFlag(false);
		setLoader(true);
		setFilePage(1);

		dispatch(set_page(1));
		dispatch(getDocumentsById({ folder: docId, sort: sortByValue, order: order, limit: paginations, page: 1, deleted: status }, ((result) => {
			dispatch({ type: "LIST_DOCUMENT", data: result.docs, totalDocRecords: result.totalDocs, folder: docId });
			setLoader(false);

			let docDta = folders.find(({ _id }) => _id === docId);
			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			setFolder(documentMenu.docs[0]?.type);
			setDocumentDetail(result && result.docs.length ? result.docs[0] : {})
			setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)
		})));
		dispatch(navigationAction(!navigationState));

	}



	/**
	 * @description method call to soft delete  document file
	 * @param {*} id  document file id
	 * @returns 
	 */
	const _deleteDocument = (id) => {
		MySwal.fire({
			title: 'Are you sure?',
			text: "You want to archive this document",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, archive it!'
		}).then((result) => {
			if (result.isConfirmed) {
				dispatch(deleteDocumentFile({ id: id }, ((result) => {
					if(result){					
							if(result?.record_active == false || result?.allDocumentsAllActionCompleted == true)
							{     setLoader(true);
                                    dispatch(getDocumentsWithTypes({...filterpayload, myAssigned: myAssignedSelected}, (result)=>{
										setTotalPages(result.totalPages)
										setsidebarActivePacketIndex(0)
                                         let docDta = folders.find(({ _id }) => _id === docId);
			                             _getDocumentTypes(result?.docs[0]?._id)
			                             setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			                             setFolder(docDta && docDta?.type ? docDta?.type : {});
										 console.log('JID 12')
			                             setDocumentList(result?.docs[0]?.documents)
							
										

									let documentSelected = false
									const archievepayload = {
										folder: result?.docs[0]?._id,
										limit: 10,
										delete: false,
										sort: sortByValue,
										order: order,
										fields: "name",
										myAssigned: myAssignedSelected
									}
									dispatch(getAllReviewRequestedDocuments(archievepayload, async (reviewrequestedresult) => {
										setsidebarActivePacketIndex(0)
                                         let docDta = folders.find(({ _id }) => _id === docId);
			                             setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			                             setFolder(docDta && docDta?.type ? docDta?.type : {});

										if(reviewrequestedresult?.docs?.length > 0){
											documentSelected = true
										}
										setReviewRequestedData(reviewrequestedresult)
										setDocumentDetail(reviewrequestedresult?.docs[0])
										setSelectedDocument(reviewrequestedresult?.docs[0]?._id)
										setReviewRequestedCount(reviewrequestedresult?.totalDocs)

										// dispatch(getAllOtherDocuments(archievepayload, async (otherresult)=>{
										// 	setOtherDocsData(otherresult)
										// 	setOtherDocs(otherresult?.docs)
										// 	setOtherDocsCount(otherresult?.totalDocs)

											var labeledDataArr = [];
											for (let i = 0; i < typeMainParent.length; i++) {
												const labeledresult = await new Promise(resolve => {
													dispatch( getAllLabeledDocuments({...archievepayload, mainparent: typeMainParent[i]?._id}, resolve ));
												});
												if (labeledresult.docs.length > 0) {
													labeledDataArr.push(labeledresult);
												}

												const CUTVresult = await new Promise(resolve => {
													dispatch(getAllCUTVDocuments({...archievepayload, mainparent: typeMainParent[i]?._id}, resolve ));
												});
						
												if (CUTVresult.docs.length > 0) {
													labeledDataArr.push(CUTVresult);
												}
												if(i == typeMainParent?.length -1 ){
													setLoader(false)
												}
											}
											if(!documentSelected){
												// if(otherresult?.docs?.length > 0){
												// 	setDocumentDetail(otherresult?.docs[0])
												// 	setSelectedDocument(otherresult?.docs[0]?._id)
												// } else {
													setDocumentDetail(labeledDataArr[0]?.docs[0])
													setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
												// }
											}
											setLabeledData(labeledDataArr);
											setPage(1)
											_getDocumentTypes(docId, false)
										}))
									// }))
								}))
							} else {
								_handleSelected(docId, elementPos);
							}
					}
				})))
				MySwal.fire(
					'Archived!',
					'Your document has been archived.',
					'success'
				)
			}
		})
	}

	// useEffect(() => {
	// 	backendSocket.on('checkDocStatus', (data) => {
	// 		dispatch(
	// 			getFileDoc({ docId: data._id, Au: null, pageNumber: 1 }, (result) => {
	// 				delete result.user
	// 				result["user"] = data.user
	// 				// console.log("docStatus",result)
	// 				setDocumentDetail(result)
	// 			})
	// 		);
	// 	})
	// }, [dispatch, documentDetail]);

    // const unlockDocument = ()=>{
	// if (documentDetail?.read_only && (documentDetail?.reading_by != userDetail?._id)) {
    //     if (userDetail?.roles?.role?.roleName.toLowerCase() == "administrator") {
	// 			// alert("admin")
	// 			setShowPermissionModal(true)
               
	// 		}
	// 	}
	// }

	function findGrandparentId(data, grandchildId) {
		for (const item of data) {
		  if (item._id === grandchildId) {
			return item.parent;
		  } else if (item.children) {
			const grandparentId = findGrandparentId(item.children, grandchildId);
			if (grandparentId) {
			  return grandparentId;
			}
		  }
		}
		return null;
	  }
	  
	  function getGrandChildrenIds(data, grandParentId) {
		const grandChildrenIds = [];
	  
		// Find the GrandParent with the specified _id
		const grandParent = data.find(item => item._id === grandParentId);
	  
		if (grandParent && grandParent.children) {
		  // Traverse the children of the GrandParent
		  grandParent.children.forEach(childLevel1 => {
			if (childLevel1.children) {
			  // Traverse the children of the children (GrandChildren)
			  childLevel1.children.forEach(childLevel2 => {
				if (childLevel2.item_level === 2) {
				  grandChildrenIds.push(childLevel2._id);
				}
			  });
			}
		  });
		}
	  
		return grandChildrenIds;
	  }
	  
	  
	  

	const editDocument = (event) => {

		

		console.log("dkasjdasjkdjerjej",documentDetail)

		//alert('hi')
		console.log("dkasjdasjkdjerjej")
		// console.log("findArrayWithId", findArrayWithId(dropData.children, documentDetail?.type_info?._id))
		// let grandParentId = findGrandparentId(dropData.children, findGrandparentId(dropData.children, documentDetail?.type_info?._id));
	  	let grandChildrenIds
		// if (documentDetail?.read_only && (documentDetail?.reading_by != userDetail?._id)) {
		// 	//alert("inside if")
		// 	if (userDetail?.roles?.role?.roleName.toLowerCase() == "administrator") {
		// 		// alert("admin")
		// 		setShowPermissionModal(true)
               
		// 	} else {
		// 		// alert("another user")
		// 		setShowModel(true)
		// 	}
		// } else{
		dispatch({type: "MY_ASSIGNED", data: myAssignedSelected})
		let typeOfDoc, typeOfDocCount;
		let totalDocs;
		let typeNeeded = false
		let docs = []
		let title = ""
		let page = 1;
		let maintype;
		if(reviewRequestedData && reviewRequestedData?.docs?.length > 0  && reviewRequestedData?.docs?.some(obj => obj._id === documentDetail._id)){
			docs = reviewRequestedData?.docs
			totalDocs = reviewRequestedData?.totalDocs
			page = reviewRequestedData?.page
			title = "Review Requested"
		}else if(otherDocsData && otherDocsData?.docs?.length > 0  && otherDocsData?.docs?.some(obj => obj._id === documentDetail._id)){
			docs = otherDocsData?.docs
			page = otherDocsData?.page
			title = "Other Documents"
		}else{
			typeNeeded = true

			const resultObject = labeledData.find(obj =>
				obj.docs.some(doc => doc._id === documentDetail._id)
			);
			
			// maintype = resultObject?.docs[0]?.type_mainparent
			// typeOfDoc = resultObject?.docs[0].packet_type._id
			// typeOfDocCount = resultObject?.totalDocs
			maintype = resultObject?.mainparentId
			grandChildrenIds = getGrandChildrenIds(dropData.children, maintype);
			title = resultObject?.mainparentName
			// title = resultObject?.docs[0]?.main_type_info?.name

			// for(let i = 0; i< documentList?.types?.length; i++){	
			// 	if(documentList && documentList?.type	s[i]?.docs?.length > 0  && documentList?.types[i]?.docs?.some(obj => obj._id === documentDetail._id)){
			// 		docs = documentList?.types[i]?.docs
			// 		title = documentList?.types[i]?.name
			// 		break
			// 	}
			// }
		}
		setDisabled(true);
		// dispatch({ type: "LIST_DOCUMENT", data: [documentDetail], totalDocRecords: docs.length, folder: docId });

		// dispatch(getDocumentsById({ folder: docId, sort: sortByValue, order: order, limit: paginations, page: 1, fields: 'name', filter: keyWord, type : type }, ((result) => {
			
		// })))

		let hasPrevPage = false;
		let hasNextPage = false;
		dispatch({ type: "ISLOADING", data: true });
		dispatch({ type: "UPDATE_DOCUMENT_FILTER", data: search });
		dispatch(rightsidebar('D'));
		dispatch(appendDocumentsById({parentName: title, folder : docId, deleted : status, page : page, limit : 10, reviewRequested : title == "Review Requested" ? true : false, otherDocuments : title == "Other Documents" ? true : false, type : typeNeeded ? grandChildrenIds : ""/*, packetType: FilterType ? typeOfDoc :null*/, myAssigned: myAssignedSelected }, (result)=>{
			// result.docs.unshift(documentDetail);
			hasPrevPage = result?.hasPrevPage
			hasNextPage = result?.hasNextPage
			let findDoc = result?.docs.filter(doc => doc._id == documentDetail._id)
			if(findDoc.length == 0 && FilterType){
				console.log("Filter")
				dispatch(getFileDoc({ docId:  documentDetail._id, Au: null, pageNumber: 1, myAssigned: myAssignedSelected }, (doc) => {
				
				dispatch({ type: "ISLOADING", data: false });
						setDisabled(false)
						if(doc){
							result.docs.push(doc)
							dispatch({ type: "LIST_DOCUMENT", data: result.docs, totalDocRecords: result.totalDocs, folder: docId });
							console.log('document id ->', documentDetail._id)

							dispatch({ type: "SET_SELECTED_FILE", selectedFileId: documentDetail._id });
						//	dispatch({ type: "SET_SELECTED_FILE", selectedFileId: documentDetail?.revisionsId[documentDetail?.revisionsId.length - 1]});
						
							history.push("/documentDetail", {selectFolder_id:doc?.folder?.id,sidebarActivePacketIndex:sidebarActivePacketIndex,title : title, type : grandChildrenIds, deleted : status, hasPrevPage: hasPrevPage, hasNextPage: hasNextPage, page: page,filterType: FilterType, packetType : typeOfDoc, myAssigned: myAssignedSelected, selectedFolderPage:page, totalFolders:1});
						}
					})
				);
			}else{	
				
				dispatch(getFileDoc({ docId:documentDetail._id, Au: null, pageNumber: 1 }, (res) => {
				     dispatch({ type: "ISLOADING", data: false });
						setDisabled(false)
						if (res) {
							let findDocument = result?.docs.filter(doc => doc._id == documentDetail._id)
							if(findDocument?.length == 0){
								result.docs.push(res)
							}
							dispatch({ type: "LIST_DOCUMENT", data: result.docs, totalDocRecords: result.totalDocs, folder: docId });
							
							dispatch({ type: "SET_SELECTED_FILE", selectedFileId: documentDetail?._id });
							history.push("/documentDetail", {selectFolder_id:res?.folder?.id,sidebarActivePacketIndex:sidebarActivePacketIndex,title : title, type : grandChildrenIds, deleted : status, hasPrevPage: hasPrevPage, hasNextPage: hasNextPage, page: page,filterType: FilterType, packetType : typeOfDoc, myAssigned: myAssignedSelected, selectedFolderPage:page,totalFolders:1});
							// result['read_only'] = true
							// backendSocket.emit('check-doc-status', documentDetail)
						}
					})
				);
			}
			
		}))
		
	}


	const _editDocument = (event) => {
		dispatch({type: "MY_ASSIGNED", data: myAssignedSelected})
		let typeNeeded = false
		let docs = []
		let title = ""
		if(documentList && documentList?.review_requested?.docs?.length > 0  && documentList?.review_requested?.docs?.some(obj => obj._id === documentDetail._id)){
			docs = documentList?.review_requested?.docs
			title = "Review Requested"
		}else if(documentList && documentList?.other_documents?.docs?.length > 0  && documentList?.other_documents?.docs?.some(obj => obj._id === documentDetail._id)){
			docs = documentList?.other_documents?.docs
			title = "Other Documents"
		}else{
			typeNeeded = true
			for(let i = 0; i< documentList?.types?.length; i++){	
				if(documentList && documentList?.types[i]?.docs?.length > 0  && documentList?.types[i]?.docs?.some(obj => obj._id === documentDetail._id)){
					docs = documentList?.types[i]?.docs
					title = documentList?.types[i]?.name
					break
				}
			}
		}
		setDisabled(true);
		dispatch({ type: "ISLOADING", data: true });
		dispatch({ type: "UPDATE_DOCUMENT_FILTER", data: search });
		dispatch(rightsidebar('D'));
		dispatch(appendDocumentsById({parentName: title, folder : docId, deleted : status, page : 1, limit : 10, docId : documentDetail._id, reviewRequested : title == "Review Requested" ? true : false, otherDocuments : title == "Other Documents" ? true : false, type : typeNeeded ? documentDetail?.type_info?._id : "", myAssigned: myAssignedSelected }, (result)=>{
			result.docs.unshift(documentDetail);
			dispatch({ type: "LIST_DOCUMENT", data: result.docs, totalDocRecords: docs.length-1, folder: docId });
			console.log('document id ->', documentDetail._id)
			dispatch({ type: "SET_SELECTED_FILE", data: documentDetail._id });
				
		}))
		
		 dispatch(
		 	getFileDoc({ docId: documentDetail._id, Au: null, pageNumber: 1 }, (result) => {
				
		 		dispatch({ type: "ISLOADING", data: false });
				if (result) {
					history.push("/documentDetail", {title : title, documentExclude : documentDetail?._id, type : documentDetail?.type_info?._id, myAssigned: myAssignedSelected  });
		 		}
		 		setDisabled(false)
		 	})
		 );
		
	}


	const editUnlabeledDocument = () => {
		let hasPrevPage = false;
		let hasNextPage = false;
		let page = otherDocsData?.page;
		let selectFolder_id = docId
		setDisabled(true);
		dispatch({ type: "ISLOADING", data: true });
		dispatch({ type: "UPDATE_DOCUMENT_FILTER", data: search });
		let params = {parentName: "unlabeled document", folder : docId, deleted : status, page : page, limit : 9, docId : documentDetail._id, otherDocuments : true, selectedDocument:documentDetail, myAssigned: myAssignedSelected, complete: documentDetail?.complete? documentDetail?.complete: false, reviewLabeled: documentDetail?.reviewLabeled? documentDetail?.reviewLabeled: false}
		dispatch(findDocumentsById(params, (result)=>{
			hasPrevPage = result?.hasPrevPage
			hasNextPage = result?.hasNextPage
			console.log("result data",result)
			// dispatch({ type: "NEXT_DOCUMENT_SELECTION", selectedFile: result?.docs, totalDocRecords: result})
			// dispatch(
				// getUnlabeledFileDoc({ docId: documentDetail._id, Au: null, pageNumber: 1 }, (result) => {
					// dispatch({ type: "ISLOADING", data: false });
					// if (result) {
						setDisabled(false)
						history.push("/dennis", {title : 'Unlabled Document',select_Folder_id:selectFolder_id,
						sidebarActivePacketIndex : sidebarActivePacketIndex, documentExclude : documentDetail?._id, type : documentDetail?.type_info?._id, hasPrevPage: hasPrevPage, hasNextPage: hasNextPage, page: page, myAssigned: myAssignedSelected });
					// }
				// })
			// );
		
		}))
		
		
	}



	const _unlockDocument = () => {
		dispatch({ type: "ISLOADING", data: true });
		// backendSocket.emit("unlockdocId",documentDetail)
		dispatch(
			unlockDoc({ docId: documentDetail._id}, (result) => { 
				dispatch({ type: "ISLOADING", data: false });
				if(result){
					setDisabled(false)
					dispatch(getDocumentsWithTypes( filterpayload, ((result) => {
						setTotalPages(result.totalPages)
						setsidebarActivePacketIndex(0)
							setLoader(false);
							setInnerLoader(false);
							setSidbarLoadingButton(true);
							let docDta = folders.find(({ _id }) => _id === docId);
							_getDocumentTypes(result?.docs[0]?._id)
							setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
							setFolder(docDta && docDta?.type ? docDta?.type : {});
							console.log('JID 13')
							setDocumentList(result?.docs[0]?.documents)
							setDocumentDetail(result?.docs[0]?.documents?.review_requested?.docs[0] ? result?.docs[0]?.documents?.review_requested?.docs[0] : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0] : result?.docs[0]?.documents?.other_documents?.docs[0] ? result?.docs[0]?.documents?.other_documents?.docs[0] : {})
							setSelectedDocument(result?.docs[0]?.documents?.review_requested?.docs[0]?._id ? result?.docs[0]?.documents?.review_requested?.docs[0]?._id : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0]?._id : result?.docs[0]?.documents?.other_documents?.docs[0]?._id ? result?.docs[0]?.documents?.other_documents?.docs[0]?._id : {})
							setPage(1);	
							setShowPermissionModal(false)				
						})));
              }
				
			})
		);	
		
	}
	


	


	/**
	 * @description method call to restore  document file
	 * @param {*} id  document file id
	 * @returns 
	 */
	const _restoreDocument = (id) => {
		MySwal.fire({
			title: 'Are you sure?',
			text: "You want to restore this document",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, restore it!'
		}).then((result) => {
			if (result.isConfirmed) {
				dispatch(updateDocumentFileStatus({ deleted: false, id: id }, ((result) => {
					if(filterpayload?.label ===  "Archived")
					  {
						let nextFolderId; 
						folders.find((_val, index) => {
							if(docId === _val._id && index + 1 < folders.length){
								nextFolderId = folders[index + 1]._id;
								return true;
							}
						})
						setDocId(nextFolderId);
						setLoader(true);
							dispatch(getDocumentsWithTypes({...filterpayload, myAssigned: myAssignedSelected},(result)=>{
								setTotalPages(result.totalPages)
								// 	    	let docDta = folders.find(({ _id }) => _id === docId);
								//             _getDocumentTypes(result?.docs[0]?._id)
			                //             setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			                //             setFolder(docDta && docDta?.type ? docDta?.type : {});
			                            // setDocumentList(result)
										setReviewRequestedCount(result.docInNeedOfReviewCount)
										//             setDocumentDetail(result?.docs[0]?.documents?.review_requested?.docs[0] ? result?.docs[0]?.documents?.review_requested?.docs[0] : result?.docs[0]?.documents?.types?.length > 0 ? result?.docs[0]?.documents?.types[0]?.docs[0] : result?.docs[0]?.documents?.other_documents?.docs[0] ? result?.docs[0]?.documents?.other_documents?.docs[0] : {})
			                //             setLoader(false);
							// 			setsidebarActivePacketIndex(0)
							}))
							dispatch(getDocumentsByIdWithTypes({ ...filterpayload, myAssigned: myAssignedSelected, deleted: true, folder: nextFolderId}, ((result) => {
								// 	let docDta = folders.find(({ _id }) => _id === docId);
								// 	setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
								// 	setFolder(docDta && docDta?.type ? docDta?.type : {});
								console.log('JID 14')
								setDocumentList(result)
								setReviewRequestedCount(result.docInNeedOfReviewCount)
								// 	setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
								// 	setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
								// 	setLoader(false);
								})))
							let documentSelected = false;
							dispatch(getAllReviewRequestedDocuments({...filterpayload, myAssigned: myAssignedSelected, deleted : true, folder : nextFolderId}, async (result)=>{
								if(result?.docs?.length > 0){
									documentSelected = true
								}
								let docDta = folders.find(({ _id }) => _id === docId);
			                    _getDocumentTypes(result?.docs[0]?._id, false)
			                    setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			                    setFolder(docDta && docDta?.type ? docDta?.type : {});
								setReviewRequestedData(result)
								setDocumentDetail(result?.docs[0])
								setSelectedDocument(result?.docs[0]?._id)

								// dispatch(getAllOtherDocuments(filterpayload, async (otherresult)=>{
								// 	setOtherDocsData(otherresult)
								// 	setOtherDocs(otherresult.docs)
								// 	setOtherDocsCount(otherresult.totalDocs)

									var labeledDataArr = [];
									for (let i = 0; i < typeMainParent.length; i++) {
										const labeledresult = await new Promise(resolve => {
											dispatch( getAllLabeledDocuments({...filterpayload, mainparent: typeMainParent[i]?._id, myAssigned: myAssignedSelected}, resolve ));
										});
										if (labeledresult.docs.length > 0) {
											labeledDataArr.push(labeledresult);
										}

										const CUTVresult = await new Promise(resolve => {
											dispatch(getAllCUTVDocuments({...filterpayload, mainparent: typeMainParent[i]?._id, myAssigned: myAssignedSelected}, resolve ));
										});
				
										if (CUTVresult.docs.length > 0) {
											labeledDataArr.push(CUTVresult);
										}
										if(i == typeMainParent?.length -1 ){
											setLoader(false)
										}
									}
									if(!documentSelected){
										// if(otherresult?.docs?.length > 0){
										// 	setDocumentDetail(otherresult?.docs[0])
										// 	setSelectedDocument(otherresult?.docs[0]?._id)
										// } else {
											setDocumentDetail(labeledDataArr[0]?.docs[0])
											setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
										// }
									}
									setLabeledData(labeledDataArr);
									setPage(1)									
								// }))
							}))
							
					}
					else
					 { 
						setLoader(true);
						dispatch(getDocumentsByIdWithTypes({ folder: docId, limit: paginations, myAssigned: myAssignedSelected, sort : sortByValue, order: order, fields: 'name', filter: keyWord,deleted:false}, ((result) => {
						// 	let docDta = folders.find(({ _id }) => _id === docId);
						// 	setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
						// 	setFolder(docDta && docDta?.type ? docDta?.type : {});
							console.log('JID 15')
							setDocumentList(result)
							setReviewRequestedCount(result.docInNeedOfReviewCount)
						// 	setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
						// 	setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
						// 	setLoader(false);
						})))

						let documentSelected = false;
						dispatch(getAllReviewRequestedDocuments({ folder: docId, limit: paginations, sort : sortByValue, order: order, fields: 'name', filter: keyWord,deleted:true, myAssigned: myAssignedSelected}, async (result)=>{
							let docDta = folders.find(({ _id }) => _id === docId);
							setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
							setFolder(docDta && docDta?.type ? docDta?.type : {});
							if(result?.docs?.length > 0){
								documentSelected = true
							}
							setReviewRequestedData(result)
							setDocumentDetail(result?.docs[0])
							setSelectedDocument(result?.docs[0]?._id)
							// dispatch(getAllOtherDocuments({ folder: docId, limit: paginations, sort : sortByValue, order: order, fields: 'name', filter: keyWord,deleted:true, myAssigned: myAssignedSelected}, async (otherresult)=>{
							// 	setOtherDocsData(otherresult)
							// 	setOtherDocs(otherresult.docs)
							// 	setOtherDocsCount(otherresult.totalDocs)

								var labeledDataArr = [];
								for (let i = 0; i < typeMainParent.length; i++) {
									const labeledresult = await new Promise(resolve => {
										dispatch( getAllLabeledDocuments({ folder: docId, limit: paginations, sort : sortByValue, order: order, fields: 'name', filter: keyWord,deleted:true, mainparent: typeMainParent[i]?._id, myAssigned: myAssignedSelected} , resolve ));
									});
									if (labeledresult.docs.length > 0) {
										labeledDataArr.push(labeledresult);
									}

									const CUTVresult = await new Promise(resolve => {
										dispatch(getAllCUTVDocuments({ folder: docId, limit: paginations, sort : sortByValue, order: order, fields: 'name', filter: keyWord,deleted:true, mainparent: typeMainParent[i]?._id, myAssigned: myAssignedSelected} , resolve ));
									});
			
									if (CUTVresult.docs.length > 0) {
										labeledDataArr.push(CUTVresult);
									}
									if(i == typeMainParent?.length -1 ){
										setLoader(false)
									}
								}
								if(!documentSelected){
									// if(otherresult?.docs?.length > 0){
									// 	setDocumentDetail(otherresult?.docs[0])
									// 	setSelectedDocument(otherresult?.docs[0]?._id)
									// } else {
										setDocumentDetail(labeledDataArr[0]?.docs[0])
										setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
									// }
								}
								setLabeledData(labeledDataArr);
								setPage(1)									
							// }))
						}))
						
					}
					_getDocumentTypes(docId, false)
				})));
				
				MySwal.fire(
					'Restore!',
					'Your document has been restored.',
					'success'
				)
			}
		})

	}


	const updateDocumentListState = (newState, _id, favourite) => {
		// Find and update within review_requested.docs
		const updatedReviewRequestedDocs = newState?.review_requested?.docs?.map(doc => {
		  if (doc._id === _id) {
			return { ...doc, favorite: favourite };
		  }
		  return doc;
		});
	
		// Find and update within other_documents.docs
		const updatedOtherDocs = newState?.other_documents?.docs?.map(doc => {
		  if (doc._id === _id) {
			return { ...doc, favorite: favourite };
		  }
		  return doc;
		});
	
		// Find and update within types[].docs
		const updatedTypes = newState?.types?.map(type => {
		  const updatedTypeDocs = type?.docs?.map(doc => {
			if (doc._id === _id) {
			  return { ...doc, favorite: favourite };
			}
			return doc;
		  });
		  return { ...type, docs: updatedTypeDocs };
		});
	
		return {
		  ...newState,
		  review_requested: { ...newState.review_requested, docs: updatedReviewRequestedDocs },
		  other_documents: { ...newState.other_documents, docs: updatedOtherDocs },
		  types: updatedTypes
		};
	  };
	/**
	  * @description method call to change favorite/unfavorite  document file
	  * @param {*} id  document file id
	  * @returns 
	  */
	const _favUnfavDoc = (favorite, id, doc, type) => {
		setSelectedIconId(id);
		let data = { favorite: favorite ? 0 : 1, id: id };
		let documentData = {...doc}
		dispatch(updateDocumentFile(data, (() => {
			const updatedState = updateDocumentListState(documentList, data?.id, data?.favorite);
			documentData.favorite = data?.favorite
			console.log('JID 16')
    		setDocumentList(updatedState);
			if(type == 'reviewrequested'){
				setReviewRequestedData((previousState)=> {
					let newState = {...previousState}
					// Find the index of the object with the specified _id
					const indexToUpdate = newState?.docs?.findIndex(obj => obj._id === id);
					// Check if the object with the given _id was found
					if (indexToUpdate !== -1) {
						// Update the object with the new fields
						newState.docs[indexToUpdate].favorite = favorite ? 0 : 1;
					}
					return newState
				})
			}else if(type == 'otherdocs'){
				setOtherDocs((previousState)=>{
					let newState = [...previousState]
					// Find the index of the object with the specified _id
					const indexToUpdate = newState?.findIndex(obj => obj._id === id);
					// Check if the object with the given _id was found
					if (indexToUpdate !== -1) {
						// Update the object with the new fields
						newState[indexToUpdate].favorite = favorite ? 0 : 1;
					}
					return newState
				})
			}else if(type == 'otherlabeleddocs'){
				setOtherLabeledDocsData((previousState)=>{
					let newState = {...previousState}
					// Find the index of the object with the specified _id
					const indexToUpdate = newState?.docs?.findIndex(obj => obj._id === id);
					// Check if the object with the given _id was found
					if (indexToUpdate !== -1) {
						// Update the object with the new fields
						newState.docs[indexToUpdate].favorite = favorite ? 0 : 1;
					}
					return newState
				})
			}else{
				setLabeledData((previousState)=>{
					let newState = [...previousState]
					newState.forEach(obj => {
						obj.docs.forEach(doc => {
						  if (doc._id === id) {
							// Update the field of the found object
							doc.favorite = favorite ? 0 : 1;
						  }
						});
					  });

					  return newState;
				})
			}
			setDocumentDetail(documentData)
			setSelectedIconId(null);
		})));
	}

	const backClick = () => {
		history.push("/dashboard");
	}

	useEffect(() => {
		return () => {
			dispatch(navigationAction(false));
			dispatch(navigationAction2(false));
		}
	}, [documentMenu, paginations, page, filePage, dispatch]);

	useEffect(() => {
		if (totalFolderRecords && totalFolderRecords > paginations * page) {
			setSidbarLoadingButton(true)
		} else {
			setSidbarLoadingButton(false)
		}
		if (totalDocRecords && totalDocRecords > paginations * filePage) {
			setFileLoadingButton(true)
		} else {
			setFileLoadingButton(false)
		}

	});

	useEffect(() => {
		if (documentMenu !== undefined && documentMenu.docs !== undefined && documentMenu.docs.length) {
			setDocId(_select_Folder_id ? _select_Folder_id : documentMenu.docs[0]._id);
			setTags(documentMenu.docs[0].tags);
			setFolder(documentMenu.docs[0]?.type);
			setDocumentDetail(documentMenu.docs[0].documents[0]);
			setSelectedFileId(documentMenu.docs[0].documents[0]?._id);
		}
	}, [documentMenu]);

	const focusSearch = (val) => {
		setFocusSearchFlag(val);
	}

	useEffect(() => {
		const handleWindowClick = () => {
			setFocusSearchFlag(false)
		}
		if (focusSearchFlag) {
			window.addEventListener('click', handleWindowClick);
		}
	}, [focusSearchFlag]);

	const [fileSearch, setFileSearch] = useState(false);
	const fileSearchCallback = (value) => {
		setFileSearch(value)
	}
	const _sortBy = (key, param, ord) => {
		console.log('working jdhsajdhaksjhdk')
		if(documentMenu?.docs?.length)
		{
			setSortByName(key);
			setSortByValue(param);
			setOrder(ord);
			setLoader(true);
			setFilePage(pagination.page);
			dispatch(set_page(1));
			setReviewRequestedPage(1)
			setLabeledDocsPage(1)
			setOtherDocsPage(1)
			setOtherLabeledDocsPage(1)
			let sortByPayload;
			// if(filterpayload?.label === "Archived")
			// {
			// 	sortByPayload = { folder: docId, sort: param, order: ord, limit: paginations, page: 1, deleted:true, filter: keyWord, fields: "name", type : type, unableToValidate: unableToValidate, otherDocuments: otherDocuments }
			// }else{
				sortByPayload = { folder: docId, sort: param, order: ord, limit: paginations, page: 1, deleted: labelStatus != "Archived" ? archiveSelected : status, filter: keyWord, fields: "name", type : type, unableToValidate: unableToValidate, otherDocuments: otherDocuments, docInreview: docInreview, myAssigned: myAssignedSelected }
			//  }
			dispatch(getDocumentsByIdWithTypes(sortByPayload, ((result) => {
				
				let docDta = folders.find(({ _id }) => _id === docId);
				setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
				setFolder(docDta && docDta?.type ? docDta?.type : {});
				console.log('JID 16')
				setDocumentList(result)
				setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
				setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
				// setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)
			})));

			let documentSelected = false;
			if(otherDocuments){
				dispatch(getAllOtherDocuments(sortByPayload, async (otherDocResult)=>{
					setOtherDocsData(otherDocResult)
					setOtherDocs(otherDocResult.docs)
					setOtherDocsCount(otherDocResult.totalDocs)

					dispatch(getAllOtherLabeledDocuments(sortByPayload, async (otherLabeledDocResult)=>{
						setOtherLabeledDocsData(otherLabeledDocResult)
						setLoader(false);
					}))
				}))
			}else{
			dispatch(getAllReviewRequestedDocuments(sortByPayload, async (result)=>{
				if(result?.docs?.length > 0){
					documentSelected = true
				}
				setReviewRequestedData(result)
				setDocumentDetail(result?.docs[0])
				setSelectedDocument(result?.docs[0]?._id)
				// setReviewRequestedCount(result.totalDocs)

				
					var labeledDataArr = [];
						for (let i = 0; i < typeMainParent.length; i++) {
							const labeledresult = await new Promise(resolve => {
							dispatch(
								getAllLabeledDocuments({...sortByPayload, mainparent: typeMainParent[i]?._id }, resolve)
							);
							});
							if (labeledresult.docs.length > 0) {
								labeledDataArr.push(labeledresult);
							}

							const CUTVresult = await new Promise(resolve => {
								dispatch(getAllCUTVDocuments({ ...sortByPayload, mainparent: typeMainParent[i]?._id}, resolve ));  
							});
	
							if (CUTVresult.docs.length > 0) {
								labeledDataArr.push(CUTVresult);
							}
							if(i == typeMainParent?.length -1 ){
								setLoader(false)
							}
						}
						setLabeledData(labeledDataArr);
						if(!documentSelected){

								setDocumentDetail(labeledDataArr[0]?.docs[0])
								setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
						}
						setLoader(false);
				
				
			}))}

			
	 }
		dispatch(navigationAction(!navigationState));


	}
	const _handleFileSearch = async (val) => {
		setKeyWord(val);
		if(documentMenu?.docs?.length)
		{
		setLoader(true);
		setFilePage(pagination.page);
		dispatch(set_page(1));
		let searchpayload;
        searchpayload={ folder: docId,sort: sortByValue , order : order, limit: 10, page: 1, fields: 'name', filter: val, deleted : labelStatus != "Archived" ? archiveSelected : status , docInreview: docInreview, otherDocuments : otherDocuments, unableToValidate : unableToValidate, type: type, myAssigned: myAssignedSelected }  
		// dispatch(getDocumentsByIdWithTypes(searchpayload, ((result) => {
		// 	setLoader(false);
		// 	let docDta = folders.find(({ _id }) => _id === docId);
		// 	setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
		// 	setFolder(docDta && docDta?.type ? docDta?.type : {});
		// 	setDocumentList(result)
		// 	setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
		// 	setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
		// })));
		setReviewRequestedPage(1)
		setLabeledDocsPage(1)
		setOtherDocsPage(1)
		setOtherLabeledDocsPage(1)

		if(otherDocuments){
			dispatch(getAllOtherDocuments(searchpayload, async (otherDocResult)=>{
				setOtherDocsData(otherDocResult)
				setOtherDocs(otherDocResult.docs)
				setOtherDocsCount(otherDocResult.totalDocs)

				dispatch(getAllOtherLabeledDocuments(searchpayload, async (otherLabeledDocResult)=>{
					setOtherLabeledDocsData(otherLabeledDocResult)
					setLoader(false)
				}))
			}))
		}else{
			let documentSelected = false;
			dispatch(getAllReviewRequestedDocuments(searchpayload, async (result)=>{
				if(result?.docs?.length > 0){
					documentSelected = true
				}
				setReviewRequestedData(result)
				setDocumentDetail(result?.docs[0])
				setSelectedDocument(result?.docs[0]?._id)
				// setReviewRequestedCount(result.totalDocs)
	
	
				var labeledDataArr = [];
				for (let i = 0; i < typeMainParent.length; i++) {
					const labeledresult = await new Promise(resolve => {
					dispatch(
						getAllLabeledDocuments({...searchpayload, mainparent: typeMainParent[i]?._id }, resolve)
					);
					});
					if (labeledresult.docs.length > 0) {
						labeledDataArr.push(labeledresult);
					}

					const CUTVresult = await new Promise(resolve => {
						dispatch(getAllCUTVDocuments({ ...searchpayload, mainparent: typeMainParent[i]?._id }, resolve ));  
					});

					if (CUTVresult.docs.length > 0) {
						labeledDataArr.push(CUTVresult);
					}
					if(i == typeMainParent?.length -1 ){
						setLoader(false)
					}
				}
				setLabeledData(labeledDataArr);
				if(!documentSelected){
					setDocumentDetail(labeledDataArr[0]?.docs[0])
					setSelectedDocument(labeledDataArr[0]?.docs[0]?._id)
				}
			}))
		}

		
	}
		dispatch(navigationAction(!navigationState));

	}

	const updateDocumentDetails = (value)=>{
		setDocumentDetail(value)
		setSelectedDocument(value?._id)
	}

	const onToggle = (node, toggled) => {
		if(!node.children){
			let deleted = status
			if(node?.count == 0){
				if(labelStatus == "Archived"){
					setStatus(true)
					deleted = true
				}else{
					setStatus(false)
					deleted = false
				}
			}
		   if(documentMenu?.docs?.length) {
			setLoader(true);
			setUnableToValidate(false)
			setOtherDocuments(false)
			setDocInreview(false)
			setSelectedQuery("")
			setType(node?._id)
			setElementPos(elementPos)
			console.log('element pos : ', elementPos)
			setFilePage(pagination.page);
			setDocId(docId);
			dispatch(set_page(1));
			setOtherDocs([])
			
			if(labelStatus == "Archived"){
				setIsArchived(true)
				setStatus(true)
			}else{
				setIsArchived(false)
				setStatus(false)
			}


			setReviewRequestedPage(1)
			setLabeledDocsPage(1)
			setOtherLabeledDocsData({})
			elementPos && elementPos != '' ? setsidebarActivePacketIndex(elementPos) : setsidebarActivePacketIndex(0)

			// dispatch(getDocumentsByIdWithTypes({ folder: docId, limit: paginations, fields: 'name', filter: keyWord, type : node?._id, deleted: deleted}, ((result) => {
			// 	if(result.count == 0){
			// 		_changeFilesStatus(false, node?._id)
			// 	}
			// 	setLoader(false);
			// 	let docDta = folders.find(({ _id }) => _id === docId);
			// 	setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			// 	setFolder(docDta && docDta?.type ? docDta?.type : {});
			// 	setDocumentList(result)
			// 	setDocumentDetail(result?.review_requested?.docs[0] ? result?.review_requested?.docs[0] : result?.types?.length > 0 ? result?.types[0]?.docs[0] : result?.other_documents?.docs[0] ? result?.other_documents?.docs[0] : {})
			// 	setSelectedDocument(result?.review_requested?.docs[0]?._id ? result?.review_requested?.docs[0]?._id : result?.types?.length > 0 ? result?.types[0]?.docs[0]?._id : result?.other_documents?.docs[0]?._id ? result?.other_documents?.docs[0]?._id : "")
			// })));

			let documentSelected = false;
			dispatch(getAllReviewRequestedDocuments({deleted : status, sort: sortByValue, order: order, folder: docId, limit: 10, fields: 'name', filter: keyWord, type : node?._id, myAssigned: myAssignedSelected}, (result)=>{
				// if(result.count == 0){
				// 	_changeFilesStatus(false, node?._id)
				// }
				// let docDta = folders.find(({ _id }) => _id === docId);
				// setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
				// setFolder(docDta && docDta?.type ? docDta?.type : {});

				setReviewRequestedData(result)
				setDocumentDetail(result?.docs[0])
				setSelectedDocument(result?.docs[0]?._id)
				if(result?.docs?.length > 0){
					documentSelected = true
				}
				dispatch(getAllLabeledDocuments({deleted : status,folder: docId, limit: 10, fields: 'name', filter: keyWord, type : node?._id, myAssigned: myAssignedSelected}, (labeledresult)=>{
					setLabeledData([labeledresult]);
					if(!documentSelected){
						setDocumentDetail(labeledresult?.docs[0])
						setSelectedDocument(labeledresult?.docs[0]?._id)
					}
					setLoader(false);
				}))

			}))
			setFilterType(true)
		}
			dispatch(navigationAction(!navigationState));
		}
		if (cursor) {
			cursor.active = false;
		}
		node.active = true;
		if (!node.name) {
			node.toggled = true;
		}
		else if (node.children) {
			node.toggled = toggled;
		}
		setCursor(node);
		setDropData(Object.assign({}, dropData))
	}

	const [isAddModelOpen, setIsModelOpen] = useState(false);

	return (
		<>

			<AutoSaveDataModal showModel={isAddModelOpen} setShowModel={setIsModelOpen} />
			<div className="documents-wrapper d-flex flex-fill overflow-auto position-relative">

				<div
					className={`sidebarListOverlay ${(navigationState || editorVisible) ? 'active' : ''}`} onClick={overClickHandler}></div>
				<div className=
					{`left-col d-flex flex-column overflow-auto sidebar-list-col 
				${navigationState ? 'active' : ''}
				`}>
					{folders &&
						<SidebarList _resetFilter={_resetFilter} sidebarLoading={sidebarLoading} sidebarLoadingLabel={sidebarLoadingLabel} sidbarLoadingButton={sidbarLoadingButton} page={page} totalPages={totalPages} handlePageChange={(page) => _handlePageChange(page)} list={folders} handleSelectedAction={(id, docIndex) => _handleSelected(id, docIndex)} _filter={(val, assignedval) => {_advanceFilter(val, assignedval)}} __filter={(sortBy, order, v, assignedval, resetLabel) => __advanceFilter(sortBy, order, v, assignedval, resetLabel)} search={(val, moreInfoObj) => _docSearch(val, moreInfoObj)} myAssignedSelected={myAssignedSelected} _myAssignedSelected={(val) => {_myAssignedFilter(val)}} menu="document" sortFn={sortFn} _innerLodder={innerLoader} handleElasticSearch={(val) => _elasticSearch(val)} elasticSearchList={elasticSearchList} focusSearchFlag={focusSearchFlag} _focusSearch={(val) => focusSearch(val)} filter={filter} totalFolderRecords={totalFolderRecords} _sidebarActivePacketIndex={sidebarActivePacketIndex} sortBySelected={sortBySelected} _sortBySelected={_sortBySelected} filterSelected={filterSelected} _filterSelected={_filterSelected} refreshFolders={refreshFolders} folderRefreshFlag={folderRefreshFlag} hasNextPage={hasNextPage} hasPrevPage={hasPrevPage}/>
					}
				</div>
				<div className="mid-col d-flex flex-column flex-fill overflow-auto">
					<PageHeader
						className={`responsive-menu-btn document-file-header ${keyWord ? 'input-has-value' : ''}
					${fileSearch ? 'active' : ''} ${queueCount !== 0 && 'queue-files-on'}`}>
						<div className="left-col d-flex align-items-center flex-fill header-filter-rw">
							<span className="ttl">Files</span>
							{/* {queueCount !== 0 && <FileQueueMsg className="desktop" queueCount={queueCount} />} */}
						</div>
						<div className="ms-auto right-col">
							<div className="header-filter-inner d-flex align-items-center">
								<div className="left-colum d-flex align-items-center">
									<FileSearchBlock fileSearchCallback={fileSearchCallback} _handleFileSearch={(val) => _handleFileSearch(val)} keyWord={keyWord} _setKeyword={(val) => setKeyWord(val)} className="col-cell" />
									<SortFilterDropdown _sortBy={(key, val, order) => _sortBy(key, val, order)} className="col-cell" sortByName={sortByName} />
									<FilterDropdown className="desktop col-cell" options={statusOptions} val={isArchived} handleVal={(val) => _changeFilesStatus(val)} disabled={labelStatus == "Archived" ? true : false}/>
								</div>
								<div className="right-colum d-flex align-items-center">
									<Button color="link" className="toggle-btn" onClick={navigationHandler}>
										<FontAwesomeIcon icon={faBars} />
									</Button>
									<Button color="link" className="toggle-btn" onClick={sidebarEditorHandler}>
										<FontAwesomeIcon icon={faEye} />
									</Button>
									<BackButton className="ms-auto" onClick={() => backClick()} />
								</div>
							</div>
						</div>
					</PageHeader>
					{/* <FileNotification /> */}


					<div className="inner-blc document-list-inner-blc d-flex flex-column flex-fill overflow-auto position-relative">
						<FilesInfoWrappper list={documentList}  dropdownData={dropData} onToggle={onToggle} documentDetail={documentDetail} onClickEvent={updateDocumentDetails} refreshFiles={() =>{refreshsssFiles(docId)}} loader={loader} resetType={resetType} getUnableToValidate={getUnableToValidate} getOtherDocuments={getOtherDocuments} getDocInNeedOfReview={getDocInNeedOfReview} selectedQuery={selectedQuery} __editDocument = {editDocument} __editUnlabeledDocument = {editUnlabeledDocument} favUnfavDoc={(status, id, doc, type) => _favUnfavDoc(status, id, doc, type)} fileStatus={status} selectedIconId={selectedIconId} handleDocSelection = {handleDocSelection} selectedDocument = {selectedDocument} fileRefreshFlag={fileRefreshFlag} getArchiveDocuments={_getArchiveDocuments} otherDocs = {otherDocs} reviewRequestedPageHandle={reviewRequestedPageHandle} otherDocsPageHandle={otherDocsPageHandle} otherLabeledDocsPageHandle ={otherLabeledDocsPageHandle} otherLabeledDocsPage={otherLabeledDocsPage} labeledPageHandle={labeledPageHandle} reviewRequestedPage={reviewRequestedPage} otherDocsPage= {otherDocsPage} labeledDocsPage={labeledDocsPage}  reviewRequestedCount={reviewRequestedCount} otherDocsCount={otherDocsCount} reviewRequestedData= {reviewRequestedData} otherDocsData={otherDocsData} otherLabeledDocsData={otherLabeledDocsData} labeledData={labeledData} isReviewRequestLoading={isReviewRequestLoading} isOtherDocsLoading={isOtherDocsLoading} isLabeledDataLoading={isLabeledDataLoading} typeSelected={typeSelected} setTypeSelected={setTypeSelected} typeSelectedGrandParent={typeSelectedGrandParent} setTypeSelectedGrandParent={setTypeSelectedGrandParent} typeSelectedParent={typeSelectedParent} setTypeSelectedParent={setTypeSelectedParent} typeSelectedChild={typeSelectedChild} setTypeSelectedChild={setTypeSelectedChild}/>
					</div>
				</div>
				<div className={`
				right-col overflow-auto sidebar-editor-col d-flex flex-column  
				${editorVisible ? 'active' : ''}
				`
				}>
					<div className="inner-content overflow-auto">
						{!loader  && documentDetail && Object.keys(documentDetail)?.length != 0 ?   (
							<FileDetail document={documentDetail} tags={tags} folder={folder} deleteDocument={(id) => _deleteDocument(id)} restoreDocument={(id) => _restoreDocument(id)} search={search} />
						) : (
							null
						)}
					</div>

					{documentDetail && documentDetail?.type == null && documentDetail?.packet_type == null && documentDetail._id  && !(documentDetail?.complete == true || documentDetail?.reviewLabeled == true)  &&
						<div className="file-detail-btns d-flex align-items-center mt-auto">
							<div className="cell">
								<Button color="primary" disabled={disabled} onClick={() => editUnlabeledDocument()}>Label</Button>
							</div>
						</div>}
					{documentDetail && documentDetail?.type == null && documentDetail?.packet_type == null && documentDetail._id  && (documentDetail?.complete == true || documentDetail?.reviewLabeled == true)  &&
						<div className="file-detail-btns d-flex align-items-center mt-auto">
							<div className="cell">
								<Button color="primary" disabled={disabled} onClick={() => editUnlabeledDocument()}>Review Labeled Document</Button>
							</div>
						</div>}
					{documentDetail && !documentDetail.deleted && documentDetail._id  && !(documentDetail?.type == null && documentDetail?.packet_type == null)  &&
						<div className="file-detail-btns d-flex align-items-center mt-auto">
							<div className="cell">
								<Button color="primary" disabled={disabled || (!userData?.purchase_advice && folder?.type === 'purchase advice')} onClick={() => editDocument()}>Edit</Button>
							</div>
							<div className="cell">
								<Button color="danger" disabled={!userData?.purchase_advice && folder?.type === 'purchase advice'} onClick={() => _deleteDocument(documentDetail && documentDetail._id)}>Archive</Button>
							</div>
						</div>}
						{/* {userDetail && userDetail?.roles?.role?.roleName.toLowerCase() == "administrator" && documentDetail?.read_only === true ?
						<div className="file-detail-btns d-flex align-items-center mt-auto">
							<div className="cell">
								<Button color="primary" disabled={documentDetail?.read_only !== true} onClick={() => unlockDocument()}>Unlock</Button>
							</div>
						</div>:''} */}
					{documentDetail && documentDetail.deleted &&  !(documentDetail?.type == null && documentDetail?.packet_type == null)  && <div className="file-detail-btns d-flex align-items-center mt-auto">
						<div className="cell">
							<Button color="primary" disabled={disabled || (!userData?.purchase_advice && folder?.type === 'purchase advice')} onClick={() => _restoreDocument(documentDetail._id)}>Restore</Button>
						</div>
						<div className="cell">
							<Button color="primary" disabled={disabled || (!userData?.purchase_advice && folder?.type === 'purchase advice')} onClick={() => editDocument()}>View</Button>
						</div>
					</div>}

				</div>
			</div>
			<ReadOnly showModal={showModal} setShowModel={(val)=> setShowModel(val)} editDocument={()=>{ _editDocument()}} />
           <EditReadOnlyPermission showPermissionModal={showPermissionModal}  setShowPermissionModal={()=> setShowPermissionModal(false)}  unlockDocument={()=>{  _unlockDocument()}}  />
      
		</>
	)
};
export default Documents;